<template>
    <div>
        <div class="fixed-top" v-if="fixedBgShow"></div>
        <div class="top-box" :class="{'play-map' : playTag}" v-if="sportInfo.gpsData">
            <baidu-map id="map" class="map-box" :class="{'play-map' : playTag}" :center="center" :zoom="zoom"
                       @ready="initMap"
                       :scroll-wheel-zoom="true">
                <!--                <img v-if="FullScreen" class="map-btn-reduce" src="@/assets/active/full.png"-->
                <!--                     @click="reduce()">-->
            </baidu-map>
            <img class="sport-back" :class="{'icon-shadow':!fixedBgShow}" @click="back"
                 :src="require(`@/assets/theme/${theme}/sport/04sportDesc/01back.png`)">
            <img class="sport-share" :class="{'icon-shadow':!fixedBgShow}" @click="gpsActionShow = true"
                 :src="require(`@/assets/theme/${theme}/sport/04sportDesc/02map.png`)">
            <!--            <img class="sport-share" :class="{'icon-shadow':!fixedBgShow}"-->
            <!--                 :src="require(`@/assets/theme/${theme}/sport/04sportDesc/03share.png`)">-->
            <img class="sport-arrow icon-shadow" v-if="showLapsGpsTag" @click="hideMapLaps()"
                 :src="require(`@/assets/theme/${theme}/sport/04sportDesc/04arrow.png`)">
            <img class="sport-arrow icon-shadow" v-if="!showLapsGpsTag" @click="showMapLaps()"
                 :src="require(`@/assets/theme/${theme}/sport/04sportDesc/04arrow1.png`)">
            <img class="sport-slice icon-shadow" @click="mapStyleShow = true"
                 :src="require(`@/assets/theme/${theme}/sport/04sportDesc/05slice.png`)">
            <img class="sport-play icon-shadow" @click="playGps"
                 :src="require(`@/assets/theme/${theme}/sport/04sportDesc/06play.png`)">
            <div class="hwpy-box" :class="{'icon-shadow':!fixedBgShow}" v-if="hwpyItem"
                 @click="showHwpyBox = !showHwpyBox">{{ hwpyItem.title }}
                <img class="hwpy-icon" v-if="showHwpyBox == 1"
                     :src="require(`@/assets/theme/${theme}/sport/04sportDesc/20up.png`)">
                <img class="hwpy-icon" v-if="showHwpyBox == 0"
                     :src="require(`@/assets/theme/${theme}/sport/04sportDesc/20down.png`)">
            </div>
            <div class="hwpy-list-box" v-if="showHwpyBox" ref="showContent">
                <div class="hwpy-item" @click="toHwpy(hwpyList[index], index)" v-for="(item, index) in hwpyList"
                     :class="{ 'col-light': hwpyIndex == index }">{{ item.title }}
                </div>
            </div>
        </div>
        <div class="top-box" v-if="!sportInfo.gpsData">
            <img class="top-box-img" v-if="sportTypeImg"
                 :src="require(`@/assets/theme/${theme}/sport/04sportDesc/17${sportTypeImg}.png`)">
            <img class="sport-back" v-if="!fixedBgShow" @click="back"
                 :src="require(`@/assets/theme/${theme}/sport/04sportDesc/01back1.png`)">
            <!--            <img class="sport-share" v-if="!fixedBgShow"-->
            <!--                 :src="require(`@/assets/theme/${theme}/sport/04sportDesc/03share1.png`)">-->
            <img class="sport-back" v-if="fixedBgShow" @click="back"
                 :src="require(`@/assets/theme/${theme}/sport/04sportDesc/01back.png`)">
            <!--            <img class="sport-share" v-if="fixedBgShow"-->
            <!--                 :src="require(`@/assets/theme/${theme}/sport/04sportDesc/03share.png`)">-->
            <div class="hwpy-box" v-if="hwpyItem" @click="showHwpyBox = !showHwpyBox">{{ hwpyItem.title }}
                <img class="hwpy-icon" v-if="showHwpyBox == 1"
                     :src="require(`@/assets/theme/${theme}/sport/04sportDesc/20up.png`)">
                <img class="hwpy-icon" v-if="showHwpyBox == 0"
                     :src="require(`@/assets/theme/${theme}/sport/04sportDesc/20down.png`)">
            </div>
            <div class="hwpy-list-box" :class="{'icon-shadow':!fixedBgShow}" v-if="showHwpyBox" ref="showContent">
                <div class="hwpy-item" @click="toHwpy(hwpyList[index], index)" v-for="(item, index) in hwpyList"
                     :class="{ 'col-light': hwpyIndex == index }">{{ item.title }}
                </div>
            </div>
        </div>
        <div class="total-box">
            <img class="user-img" :src="userAvatar ? userAvatar : defaultImg">
            <div class="total-top">
                <img v-if="watchImg" class="watch-img"
                     :src="require(`@/assets/theme/${theme}/sport/04sportDesc/14${watchImg}.png`)">
                <span v-if="watchName">{{ watchName }}</span>
                <span v-if="watchName" class="dot">·</span>
                <span v-if="sportInfo"> {{ sportType }}</span>
                <span v-if="hwpyItem" class="dot">·</span>
                <span v-if="hwpyItem"> {{ hwpyItem.title }}</span>
            </div>
            <div class="distance-box">
                <span v-if="runTotalShow || rideTotalShow"><span
                    class="distance-num">{{
                        sportInfo.distance ? (sportInfo.distance / 100000).toFixed(2) : '0.00'
                    }}</span>公里</span>
                <span v-else-if="triathlonTotalShow"><span
                    class="distance-num">{{
                        triathlon.distance ? (triathlon.distance / 100000).toFixed(2) : '0.00'
                    }}</span>公里</span>
                <span v-else-if="swimTotalShow"><span
                    class="distance-num">{{ sportInfo.distance ? parseInt(sportInfo.distance / 100) : '0.00' }}</span>米</span>
                <span v-else-if="powerTotalShow"><span
                    class="distance-num">{{ sportInfo.powerGroupNum ? sportInfo.powerGroupNum : 0 }}</span>组</span>
                <span v-else-if="indoorclimbTotalShow"><span
                    class="distance-num">{{ sportInfo.totalLine ? sportInfo.totalLine : 0 }}</span>线路总数</span>
                <span v-else-if="hwpyTotalShow"><span
                    class="distance-num">{{ sportInfo.ropeDistance ? sportInfo.ropeDistance : 0 }}</span>绳距</span>
                <span v-else-if="ballTotalShow"><span
                    class="distance-num">{{ sportInfo.powerCountNum ? sportInfo.powerCountNum : 0 }}</span>次挥拍</span>
                <span v-else-if="paTotalShow"><span
                    class="distance-num">{{ sportInfo.floorCount ? sportInfo.floorCount : 0 }}</span>层</span>
                <span v-else><span
                    class="distance-num">{{ parseInt(sportInfo.calories / 1000) }}</span>千卡</span>
                <span class="start-time">{{ formatStartTime }}</span>
            </div>
            <!--            <div class="speed-box" v-if="sportInfo.gpsData">-->
            <!--                <div class="fast">快</div>-->
            <!--                <div class="slow">慢</div>-->
            <!--            </div>-->
            <div class="speed-box-bg">
            </div>
            <div class="total-info" v-if="sportType!=='骑行'">
                <van-row>
                    <van-col span="8" v-if="sportType != '铁人三项'">
                        <div class="total-item">
                            <div class="total-value"><span
                                class="total-value-num">{{ formatSeconds2(sportInfo.actTime) }}</span></div>
                            <div class="total-key">运动时长</div>
                        </div>
                    </van-col>
                    <van-col span="8" v-if="sportType == '铁人三项'">
                        <div class="total-item">
                            <div class="total-value"><span
                                class="total-value-num">{{
                                    triathlon && triathlon.actTime ? formatSeconds2(triathlon.actTime) : ''
                                }}</span>
                            </div>
                            <div class="total-key">运动时长</div>
                        </div>
                    </van-col>
                    <van-col span="8">
                        <div class="total-item">
                            <div class="total-value"><span
                                class="total-value-num">{{ sportInfo.avgHeartrate }}</span>次/分
                            </div>
                            <div class="total-key">平均心率</div>
                        </div>
                    </van-col>
                    <van-col span="8" v-if="sportType != '铁人三项' && !otherTotalShow">
                        <div class="total-item">
                            <div class="total-value"><span
                                class="total-value-num">{{ parseInt(sportInfo.calories / 1000) }}</span>千卡
                            </div>
                            <div class="total-key">运动能耗</div>
                        </div>
                    </van-col>
                    <van-col span="8" v-if="sportType != '铁人三项' && otherTotalShow">
                        <div class="total-item" v-if="sportType != '射箭'">
                            <div class="total-value"><span
                                class="total-value-num">{{ sportInfo.maxHeartrate }}</span>次/分
                            </div>
                            <div class="total-key">最高心率</div>
                        </div>
                        <div class="total-item" v-if="sportType == '射箭'">
                            <div class="total-value"><span
                                class="total-value-num">{{ sportInfo.respiratoryRateAvg }}</span>次/分
                            </div>
                            <div class="total-key">平均呼吸频率</div>
                        </div>
                    </van-col>
                    <van-col span="8" v-if="sportType == '铁人三项'">
                        <div class="total-item">
                            <div class="total-value"><span
                                class="total-value-num">{{ parseInt(triathlon.calories / 1000) }}</span>千卡
                            </div>
                            <div class="total-key">运动能耗</div>
                        </div>
                    </van-col>
                    <div
                        v-if="sportType == '跑步' || sportType == '登山' || sportType == '室内跑' || sportType == '徒步越野' || sportType == '越野跑'|| sportType == '健走' || sportType == '马拉松' || sportType == '操场跑'">
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ formatSeconds(paceMath[2]) }}</span>/公里
                                </div>
                                <div class="total-key">平均配速</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ avgStride }}</span>米
                                </div>
                                <div class="total-key">平均步幅</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ stepMath[2] }}</span>步/分
                                </div>
                                <div class="total-key">平均步频</div>
                            </div>
                        </van-col>
                    </div>
                    <div v-if="sportType == '登山' || sportType == '徒步越野'">
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ sportInfo.upHeight }}</span>米
                                </div>
                                <div class="total-key">累计爬升</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ sportInfo.downHeight }}</span>米
                                </div>
                                <div class="total-key">累计下降</div>
                            </div>
                        </van-col>
                    </div>
                    <div v-if="sportType == '滑雪登山' || (sportType == '户外攀岩' && !hwpyItem)">
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ formatSeconds2(restTime) }}</span>
                                </div>
                                <div class="total-key">休息时长</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ sportInfo.upHeight }}</span>米
                                </div>
                                <div class="total-key">累计爬升</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ sportInfo.downHeight }}</span>米
                                </div>
                                <div class="total-key">累计下降</div>
                            </div>
                        </van-col>
                        <van-col span="8" v-if="sportInfo.sportType == '户外攀岩'">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ sportInfo.maxHard }}</span>
                                </div>
                                <div class="total-key">最高难度</div>
                            </div>
                        </van-col>
                    </div>
                    <div v-if="sportType == '户外攀岩' && hwpyItem && hwpyItem.lapsState == 0">
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ formatSeconds2(restTime) }}</span>
                                </div>
                                <div class="total-key">休息时长</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ sportInfo.upHeight }}</span>米
                                </div>
                                <div class="total-key">累计爬升</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ sportInfo.maxHard }}</span>
                                </div>
                                <div class="total-key">最高难度</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{
                                        sportInfo.distance ? (sportInfo.distance / 100000).toFixed(2) : '0.00'
                                    }}</span>公里
                                </div>
                                <div class="total-key">距离</div>
                            </div>
                        </van-col>
                    </div>
                    <div v-if="sportType == '户外攀岩' && hwpyItem && hwpyItem.lapsState == 1">
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ formatSeconds2(restTime) }}</span>
                                </div>
                                <div class="total-key">休息时长</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ sportInfo.downHeight }}</span>米
                                </div>
                                <div class="total-key">累计下降</div>
                            </div>
                        </van-col>
                    </div>
                    <div v-if="sportType == '室内攀岩'">
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ formatSeconds2(sportInfo.restTime) }}</span>
                                </div>
                                <div class="total-key">休息时长</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ sportInfo.upHeight }}</span>米
                                </div>
                                <div class="total-key">累计爬升</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ sportInfo.maxHard }}</span>
                                </div>
                                <div class="total-key">最高难度</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ sportInfo.fallCount }}</span>次
                                </div>
                                <div class="total-key">总坠落</div>
                            </div>
                        </van-col>
                    </div>
                    <div v-if="sportType == '室内游泳'">
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{
                                        sportInfo.avgStrokeFrequency ? sportInfo.avgStrokeFrequency : '--'
                                    }}</span>次/分钟
                                </div>
                                <div class="total-key">平均划频</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{
                                        paceMath[1] == '--' ? paceMath[1] :
                                            formatSeconds(paceMath[1])
                                    }}</span>/百米
                                </div>
                                <div class="total-key">最快泳速</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ sportInfo.avgSwolf ? sportInfo.avgSwolf : '--' }}</span>
                                </div>
                                <div class="total-key">平均SWOLF</div>
                            </div>
                        </van-col>
                    </div>
                    <div v-if="powerTotalShow">
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ formatSeconds2(restTime) }}</span>
                                </div>
                                <div class="total-key">休息时长</div>
                            </div>
                        </van-col>
                        <van-col span="8" v-if="sportType == '跳绳'">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ sportInfo.avgFrequency }}</span>次/分
                                </div>
                                <div class="total-key">平均频率</div>
                            </div>
                        </van-col>
                        <van-col span="8"
                                 v-if="sportType == '深蹲' || sportType == '俯卧撑' || sportType == '卷腹' || sportType == '跳绳' ">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ sportInfo.powerCountNum }}</span>次
                                </div>
                                <div class="total-key">总计数</div>
                            </div>
                        </van-col>
                    </div>
                    <div v-if="triathlonTotalShow">
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{
                                        triathlon && triathlon.swim ? formatSeconds2(triathlon.swim.actTime) : '00:00:00'
                                    }}</span>
                                </div>
                                <div class="total-key">游泳时长</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{
                                        triathlon && triathlon.ride ? formatSeconds2(triathlon.ride.actTime) : '00:00:00'
                                    }}</span>
                                </div>
                                <div class="total-key">骑行时长</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{
                                        triathlon && triathlon.run ? formatSeconds2(triathlon.run.actTime) : '00:00:00'
                                    }}</span>
                                </div>
                                <div class="total-key">跑步时长</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{
                                        triathlon.firstSwitch ? formatSeconds2(triathlon.firstSwitch.actTime) : formatSeconds2(0)
                                    }}</span>
                                </div>
                                <div class="total-key">第一次转换时长</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{
                                        triathlon.secondSwitch ? formatSeconds2(triathlon.secondSwitch.actTime) : formatSeconds2(0)
                                    }}</span>
                                </div>
                                <div class="total-key">第二次转换时长</div>
                            </div>
                        </van-col>
                    </div>
                    <div v-if="sportType == '冲浪' || sportType == '帆板' || sportType == '骑马' || sportType == '轮滑'">
                        <van-col span="9">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{
                                        sportInfo.avgSpeed ? getSpeed(sportInfo.avgSpeed) : '--'
                                    }}</span>公里/小时
                                </div>
                                <div class="total-key">平均速度</div>
                            </div>
                        </van-col>
                        <van-col span="9">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{
                                        sportInfo.maxSpeed ? getSpeed(sportInfo.maxSpeed) : '--'
                                    }}</span>公里/小时
                                </div>
                                <div class="total-key">最快速度</div>
                            </div>
                        </van-col>
                    </div>
                    <div v-if="sportType == '越野滑雪'">
                        <van-col span="9">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{
                                        sportInfo.maxSpeed ? getSpeed(sportInfo.maxSpeed) : '--'
                                    }}</span>公里/小时
                                </div>
                                <div class="total-key">最快速度</div>
                            </div>
                        </van-col>
                        <van-col span="6">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ sportInfo.upHeight ? sportInfo.upHeight : '--' }}</span>米
                                </div>
                                <div class="total-key">累计爬升</div>
                            </div>
                        </van-col>
                        <van-col span="6">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ sportInfo.downHeight ? sportInfo.downHeight : '--' }}</span>米
                                </div>
                                <div class="total-key">累计下降</div>
                            </div>
                        </van-col>
                    </div>
                    <div v-if="sportType == '爬楼'">
                        <van-col span="6">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ sportInfo.upHeight ? sportInfo.upHeight : '--' }}</span>米
                                </div>
                                <div class="total-key">累计爬升</div>
                            </div>
                        </van-col>
                        <van-col span="6">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ sportInfo.downHeight ? sportInfo.downHeight : '--' }}</span>米
                                </div>
                                <div class="total-key">累计下降</div>
                            </div>
                        </van-col>
                    </div>
                    <div v-if="sportType == '跳伞'">
                        <van-col span="9">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{
                                        sportInfo.maxSpeed ? getSpeed(sportInfo.maxSpeed) : '--'
                                    }}</span>公里/小时
                                </div>
                                <div class="total-key">最快速度</div>
                            </div>
                        </van-col>
                        <van-col span="6">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ sportInfo.downHeight ? sportInfo.downHeight : '--' }}</span>米
                                </div>
                                <div class="total-key">累计下降</div>
                            </div>
                        </van-col>
                    </div>
                </van-row>
            </div>
            <div class="total-info total-van-row" v-if="sportType=='骑行'">
                <van-row>
                    <van-col span="9">
                        <div class="total-item">
                            <div class="total-value"><span
                                class="total-value-num">{{ formatSeconds2(sportInfo.actTime) }}</span></div>
                            <div class="total-key">运动时长</div>
                        </div>
                    </van-col>
                    <van-col span="9">
                        <div class="total-item">
                            <div class="total-value"><span
                                class="total-value-num">{{ sportInfo.avgHeartrate }}</span>次/分
                            </div>
                            <div class="total-key">平均心率</div>
                        </div>
                    </van-col>
                    <van-col span="6">
                        <div class="total-item">
                            <div class="total-value"><span
                                class="total-value-num">{{ parseInt(sportInfo.calories / 1000) }}</span>千卡
                            </div>
                            <div class="total-key">运动能耗</div>
                        </div>
                    </van-col>
                    <div>
                        <van-col span="9">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{
                                        sportInfo.avgSpeed ? getSpeed(sportInfo.avgSpeed) : '--'
                                    }}</span>公里/小时
                                </div>
                                <div class="total-key">平均速度</div>
                            </div>
                        </van-col>
                        <van-col span="9">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{
                                        sportInfo.maxSpeed ? getSpeed(sportInfo.maxSpeed) : '--'
                                    }}</span>公里/小时
                                </div>
                                <div class="total-key">最快速度</div>
                            </div>
                        </van-col>
                        <van-col span="6">
                            <div class="total-item">
                                <div class="total-value"><span
                                    class="total-value-num">{{ sportInfo.upHeight ? sportInfo.upHeight : '--' }}</span>米
                                </div>
                                <div class="total-key">累计爬升</div>
                            </div>
                        </van-col>
                    </div>
                </van-row>
            </div>
            <div class="total-box-gap"></div>
        </div>
        <div class="triathlon-switch-box" v-if="triathlonTotalShow">
            <van-tabs v-model="activeType"
                      @change="changeTriathlon"
                      title-active-color="var(--text-color-1)"
                      title-inactive-color="var(--text-color-3)"
                      line-height="2"
                      color="var(--text-color-1)"
            >
                <van-tab title="游泳"></van-tab>
                <van-tab title="骑行" :disabled="!triathlon.ride"></van-tab>
                <van-tab title="跑步" :disabled="!triathlon.run"></van-tab>
            </van-tabs>
            <div class="triathlon-total-box">
                <div class="icon-box">
                    <img class="icon-box-img"
                         :src="require(`@/assets/theme/${theme}/sport/04sportDesc/18${sportInfo.sportType}.png`)">
                </div>
                <div class="triathlon-distance">
                    <span
                        class="triathlon-distance-num">{{
                            sportInfo.distance ? (sportInfo.distance / 100000).toFixed(2) : '0.00'
                        }}</span>公里
                </div>
                <div class="triathlon-duration">{{ triathlonFormatStartTime }}</div>
            </div>
        </div>
        <div class="chart-box"
             v-if="hrChartShow || paceChartShow || speedChartShow || swimChartShow || stepChartShow || heightChartShow">
            <div class="item-box" v-if="hrChartShow">
                <div class="chart-title">
                    <img class="chart-icon" :src="require(`@/assets/theme/${theme}/sport/04sportDesc/07hr.png`)">
                    心率<span class="chart-unit">（次/分）</span>
                </div>
                <div class="chart-math">
                    <van-row>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{ hrMath[0] }}</div>
                                <div class="total-key">最高</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{ hrMath[1] }}</div>
                                <div class="total-key">最低</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{ hrMath[2] }}</div>
                                <div class="total-key">平均</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div id="hr-chart" class="chart"></div>
                <div class="hr-range-box">
                    <div class="hr-line">
                        <div class="hr-line-title">极限区间</div>
                        <div class="hr-line-desc">≥{{ hRangeZoneData[4] }} 次/分</div>
                        <div class="percent">
                            <van-progress :percentage="hRangeData[4]" stroke-width="10"
                                          track-color="var(--bg-color-2)" color="var(--chart-color-3)"/>
                        </div>
                        <div class="hr-line-percent">{{ hRangeData[4] }}%</div>
                        <div class="hr-line-time">{{ hRangeDataTime[4] }}</div>
                    </div>
                    <div class="hr-line">
                        <div class="hr-line-title">无氧区间</div>
                        <div class="hr-line-desc">{{ hRangeZoneData[3] }}-{{ hRangeZoneData[4] }} 次/分</div>
                        <div class="percent">
                            <van-progress :percentage="hRangeData[3]" stroke-width="10"
                                          track-color="var(--bg-color-2)" color="var(--chart-color-10)"/>
                        </div>
                        <div class="hr-line-percent">{{ hRangeData[3] }}%</div>
                        <div class="hr-line-time">{{ hRangeDataTime[3] }}</div>
                    </div>
                    <div class="hr-line">
                        <div class="hr-line-title">耐力区间</div>
                        <div class="hr-line-desc">{{ hRangeZoneData[2] }}-{{ hRangeZoneData[3] }} 次/分</div>
                        <div class="percent">
                            <van-progress :percentage="hRangeData[2]" stroke-width="10"
                                          track-color="var(--bg-color-2)" color="var(--chart-color-8)"/>
                        </div>
                        <div class="hr-line-percent">{{ hRangeData[2] }}%</div>
                        <div class="hr-line-time">{{ hRangeDataTime[2] }}</div>
                    </div>
                    <div class="hr-line">
                        <div class="hr-line-title">有氧区间</div>
                        <div class="hr-line-desc">{{ hRangeZoneData[1] }}-{{ hRangeZoneData[2] }} 次/分</div>
                        <div class="percent">
                            <van-progress :percentage="hRangeData[1]" stroke-width="10"
                                          track-color="var(--bg-color-2)" color="var(--chart-color-3)"/>
                        </div>
                        <div class="hr-line-percent">{{ hRangeData[1] }}%</div>
                        <div class="hr-line-time">{{ hRangeDataTime[1] }}</div>
                    </div>
                    <div class="hr-line">
                        <div class="hr-line-title">热身区间</div>
                        <div class="hr-line-desc">{{ hRangeZoneData[0] }}-{{ hRangeZoneData[1] }} 次/分</div>
                        <div class="percent">
                            <van-progress :percentage="hRangeData[0]" stroke-width="10"
                                          track-color="var(--bg-color-2)" color="var(--chart-color-1)"/>
                        </div>
                        <div class="hr-line-percent">{{ hRangeData[0] }}%</div>
                        <div class="hr-line-time">{{ hRangeDataTime[0] }}</div>
                    </div>
                </div>
                <div class="hr-split-line"></div>
            </div>
            <div class="item-box" v-if="paceChartShow">
                <div class="chart-title">
                    <img class="chart-icon" :src="require(`@/assets/theme/${theme}/sport/04sportDesc/08race.png`)">
                    配速<span class="chart-unit">（/公里）</span>
                </div>
                <div class="chart-math">
                    <van-row>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{ formatSeconds(paceMath[1]) }}</div>
                                <div class="total-key">最快</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{ formatSeconds(paceMath[0]) }}</div>
                                <div class="total-key">最慢</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{ formatSeconds(paceMath[2]) }}</div>
                                <div class="total-key">平均</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div id="pace-chart" class="chart"></div>
                <div class="pace-split-line"></div>
            </div>
            <div class="item-box" v-if="speedChartShow">
                <div class="chart-title">
                    <img class="chart-icon" :src="require(`@/assets/theme/${theme}/sport/04sportDesc/08race.png`)">
                    速度<span class="chart-unit">（公里/小时）</span>
                </div>
                <div class="chart-math">
                    <van-row>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{
                                        sportInfo.maxSpeed ? getSpeed(sportInfo.maxSpeed) :
                                            '--'
                                    }}
                                </div>
                                <div class="total-key">最快</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{ getSpeed(speedMath[1]) }}</div>
                                <div class="total-key">最慢</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{
                                        sportInfo.avgSpeed ? getSpeed(sportInfo.avgSpeed) :
                                            '--'
                                    }}
                                </div>
                                <div class="total-key">平均</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div id="speed-chart" class="chart"></div>
                <div class="pace-split-line"></div>
            </div>
            <div class="item-box" v-if="swimChartShow">
                <div class="chart-title">
                    <img class="chart-icon" :src="require(`@/assets/theme/${theme}/sport/04sportDesc/08race.png`)">
                    百米泳速<span class="chart-unit">（/百米）</span>
                </div>
                <div class="chart-math">
                    <van-row>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{ formatSeconds(paceMath[1]) }}</div>
                                <div class="total-key">最快</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{ formatSeconds(paceMath[0]) }}</div>
                                <div class="total-key">最慢</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{ formatSeconds(paceMath[2]) }}</div>
                                <div class="total-key">平均</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div id="swim-chart" class="chart"></div>
                <div class="pace-split-line"></div>
            </div>
            <div class="item-box" v-if="stepChartShow">
                <div class="chart-title">
                    <img class="chart-icon" :src="require(`@/assets/theme/${theme}/sport/04sportDesc/09step.png`)">
                    步频<span class="chart-unit">（步/分）</span>
                </div>
                <div class="chart-math">
                    <van-row>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{ stepMath[0] }}</div>
                                <div class="total-key">最大</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{ stepMath[1] }}</div>
                                <div class="total-key">最小</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{ stepMath[2] }}</div>
                                <div class="total-key">平均</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div id="step-chart" class="chart"></div>
                <div class="pace-split-line"></div>
            </div>
            <div class="item-box" v-if="hxplChartShow">
                <div class="chart-title">
                    <img class="chart-icon" :src="require(`@/assets/theme/${theme}/sport/04sportDesc/23hxpl.svg`)">
                    呼吸频率<span class="chart-unit">（次/分）</span>
                </div>
                <div class="chart-math">
                    <van-row>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{ sportInfo.respiratoryRateMax }}</div>
                                <div class="total-key">最大</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{ sportInfo.respiratoryRateMin }}</div>
                                <div class="total-key">最小</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{ sportInfo.respiratoryRateAvg }}</div>
                                <div class="total-key">平均</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div id="hxpl-chart" class="chart"></div>
                <div class="pace-split-line"></div>
            </div>
            <div class="height-box" v-if="heightChartShow">
                <div class="chart-title">
                    <img class="chart-icon"
                         :src="require(`@/assets/theme/${theme}/sport/04sportDesc/10height.png`)">
                    海拔<span class="chart-unit">（米）</span>
                </div>
                <div class="chart-math">
                    <van-row>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{ heightMath[0] }}</div>
                                <div class="total-key">最高</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{ heightMath[1] }}</div>
                                <div class="total-key">最低</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{ heightMath[2] }}</div>
                                <div class="total-key">平均</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div id="height-chart" class="chart"></div>
                <div class="height-best">
                    <img class="height-up" :src="require(`@/assets/theme/${theme}/sport/04sportDesc/15up.png`)">
                    <div class="height-up-key">累计爬升</div>
                    <div class="height-up-value">{{ sportInfo.upHeight }}</div>
                    <img class="height-down" :src="require(`@/assets/theme/${theme}/sport/04sportDesc/16down.png`)">
                    <div class="height-down-key">累计下降</div>
                    <div class="height-down-value">{{ sportInfo.downHeight }}</div>
                </div>
            </div>
        </div>
        <div class="train-box">
            <div class="train-title">训练效果</div>
            <div class="circle-box">
                <div class="aer-box">
                    <van-circle
                        v-model="aerModel"
                        :rate="aerRate"
                        :speed="50"
                        :stroke-width="80"
                        layer-color="var(--bg-color-1)"
                        :clockwise="false"
                        color="var(--chart-color-3)"
                        size="86px"
                    />
                    <div class="aer-text-box">
                        <div class="aer-value">{{ (sportInfo.aerobicEffect / 10).toFixed(1) }}</div>
                        <div class="aer-key">有氧</div>
                        <div class="aer-level">{{ getEffectLevel(sportInfo.aerobicEffect) }}</div>
                    </div>
                </div>
                <div class="anaer-box">
                    <van-circle
                        v-model="anaerModel"
                        :rate="anaerRate"
                        :speed="50"
                        :stroke-width="80"
                        layer-color="var(--bg-color-1)"
                        :clockwise="false"
                        color="var(--chart-color-8)"
                        size="86px"
                    />
                    <div class="aer-text-box">
                        <div class="aer-value">{{ (sportInfo.anaerobicEffect / 10).toFixed(1) }}</div>
                        <div class="aer-key">无氧</div>
                        <div class="aer-level">{{ getEffectLevel(sportInfo.anaerobicEffect) }}</div>
                    </div>
                </div>
            </div>
            <div class="train-load-box" :class="{'train-recover-box': is806}">
                <div class="train-load-key" v-if="!is806">体能损耗值<span
                    class="train-load-value">{{
                        sportInfo.stamina ? (1000 - sportInfo.stamina) / 10 + '%' : '--'
                    }}</span>
                </div>
                <div class="train-load-key" v-if="is806">恢复时间：<span
                    class="train-recover-value">{{ Math.floor(sportInfo.recoveryTime / 60) }}</span>小时<span
                    class="train-recover-value">{{ Math.floor(sportInfo.recoveryTime % 60) }}</span>分钟
                </div>
            </div>
        </div>
        <div class="laps-box"
             v-if="lapsShow&&sportInfo.sportType != '滑雪登山'&&sportInfo.sportType != '室内攀岩'&&!hwpyTotalShow&&!xiajiangTotalShow">
            <div><span class="train-title">{{ lapsName }}</span></div>
            <div class="laps-table-box">
                <div class="gap"></div>
                <table class="laps-table-title" cellspacing="0">
                    <tr>
                        <th v-for="(item, index) in lapsTitle" :key="index">{{ item }}</th>
                    </tr>
                </table>
                <table class="laps-table" cellspacing="0">
                    <tr v-for="(item, index) in lapsData" :key="index">
                        <td v-for="(col, colIndex) in item" :key="colIndex">{{ col }}</td>
                    </tr>
                </table>
            </div>
            <div class="gap"></div>
        </div>
        <div class="laps-box"
             v-if="lapsShow&&sportInfo.sportType == '滑雪登山'">
            <div><span class="train-title">{{ lapsName }}</span></div>
            <div class="laps-table-box">
                <div class="gap"></div>
                <table class="c5-title" cellspacing="0">
                    <tr>
                        <th v-for="(item, index) in lapsTitle" :key="index">{{ item }}</th>
                    </tr>
                </table>
                <table class="c5" cellspacing="0">
                    <tr v-for="(item, index) in lapsData" :key="index">
                        <td v-for="(col, colIndex) in item" :key="colIndex">
                            <div v-if="colIndex == 0 && col == 0"><img
                                :src="require(`@/assets/theme/${theme}/sport/04sportDesc/19up.png`)"
                                class='laps-icon'></div>
                            <div v-if="colIndex == 0 && col == 1"><img
                                :src="require(`@/assets/theme/${theme}/sport/04sportDesc/19down.png`)"
                                class='laps-icon'></div>
                            <div v-if="colIndex != 0">{{ col }}</div>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="gap"></div>
        </div>
        <div class="laps-box"
             v-if="lapsShow&&sportInfo.sportType == '室内攀岩'">
            <div><span class="train-title">{{ lapsName }}</span></div>
            <div class="laps-table-box">
                <div class="gap"></div>
                <table class="laps-table-title" cellspacing="0">
                    <tr>
                        <th v-for="(item, index) in lapsTitle" :key="index">{{ item }}</th>
                    </tr>
                </table>
                <table class="laps-table" cellspacing="0">
                    <tr v-for="(item, index) in lapsData" :key="index">
                        <td v-for="(col, colIndex) in item" :key="colIndex">
                            <div v-if="colIndex == 0">
                                {{ col[0] }}
                                <span class="col-light" v-if="col[1] == 0 || col[1] == '完成'">（完成）</span>
                                <span class="col-shadow" v-if="col[1] == 1 || col[1] == '尝试'">（尝试）</span>
                            </div>
                            <div v-if="colIndex > 0">{{ col }}</div>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="gap"></div>
        </div>
        <div class="laps-box"
             v-if="lapsShow&&sportInfo.sportType == '户外攀岩'&&!hwpyItem">
            <div><span class="train-title">{{ lapsName }}</span></div>
            <div class="laps-table-box">
                <div class="gap"></div>
                <table class="laps-table-title" cellspacing="0">
                    <tr>
                        <th v-for="(item, index) in lapsTitle" :key="index">{{ item }}</th>
                    </tr>
                </table>
                <table class="laps-table" cellspacing="0">
                    <tr v-for="(item, index) in lapsData" :key="index">
                        <td v-for="(col, colIndex) in item" :key="colIndex">
                            <div v-if="colIndex == 0">
                                <div v-if="colIndex == 0 && col[1] == 0"><img
                                    :src="require(`@/assets/theme/${theme}/sport/04sportDesc/19up.png`)"
                                    class='laps-icon'> {{ col[0] }}
                                </div>
                                <div v-if="colIndex == 0 && col[1] == 1"><img
                                    :src="require(`@/assets/theme/${theme}/sport/04sportDesc/19down.png`)"
                                    class='laps-icon'> {{ col[0] }}
                                </div>
                            </div>
                            <div v-if="colIndex > 0 && colIndex < 3 ">{{ col }}</div>
                            <div class="col-light" v-if="colIndex == 3 " @click="toHwpy(hwpyList[index], index)">查看详情
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="gap"></div>
        </div>
        <div class="laps-box"
             v-if="lapsShow&&sportInfo.sportType == '户外攀岩'&&hwpyItem">
            <div><span class="train-title">{{ lapsName }}</span></div>
            <div class="laps-table-box">
                <div class="gap"></div>
                <table class="laps-table-title" cellspacing="0">
                    <tr>
                        <th v-for="(item, index) in lapsTitle" :key="index">{{ item }}</th>
                    </tr>
                </table>
                <table class="laps-table" cellspacing="0">
                    <tr v-for="(item, index) in lapsData" :key="index">
                        <td v-for="(col, colIndex) in item" :key="colIndex">
                            <div>{{ col }}</div>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="gap"></div>
        </div>
        <div class="gap"></div>
        <van-action-sheet
            v-model="gpsActionShow"
            :actions="gpsActions"
            cancel-text="取消"
            close-on-click-action
            @select="selectGpsAction"
        />
        <van-action-sheet
            v-model="exportShow"
            :actions="exportGpsActions"
            cancel-text="取消"
            close-on-click-action
            @select="selectExportAction"
        />
        <van-dialog
            v-model="publishShow"
            title="请输入云迹名称"
            show-cancel-button
            confirmButtonColor="var(--chart-color-1)"
            cancelButtonColor="var(--text-color-2)"
            @confirm="sendPublish"
            :before-close="onBeforeClose"
        >
            <div class="sub-title">支持10位以内的汉字和英文</div>
            <div class="publish-input">
                <van-form>
                    <van-field
                        v-model="publishName"
                        placeholder="请输入"
                        :rules="[{ pattern}]"
                    />
                </van-form>
            </div>
        </van-dialog>
        <van-action-sheet
            v-model="mapStyleShow"
            title="地图样式"
            :closeable="false"
            cancel-text="确认"
            @cancel="confirmMapStype"
        >
            <div class="map-style-box">
                <div class="map-style-list" @click="selectMap = 1">
                    <img class="map-icon" :class="{'map-icon-selected':selectMap == 1}"
                         :src="require(`@/assets/theme/${theme}/sport/04sportDesc/21map1.png`)">
                    <div>隐私模式</div>
                </div>
                <div class="map-style-list" @click="selectMap = 2">
                    <img class="map-icon" :class="{'map-icon-selected':selectMap == 2}"
                         :src="require(`@/assets/theme/${theme}/sport/04sportDesc/21map2.png`)">
                    <div>标准</div>
                </div>
                <div class="map-style-list" @click="selectMap = 3">
                    <img class="map-icon" :class="{'map-icon-selected':selectMap == 3}"
                         :src="require(`@/assets/theme/${theme}/sport/04sportDesc/21map3.png`)">
                    <div>卫星</div>
                </div>
                <!--                <div class="map-style-list" @click="selectMap = 4">-->
                <!--                    <img class="map-icon" :class="{'map-icon-selected':selectMap == 4}" :src="require(`@/assets/theme/${theme}/sport/04sportDesc/21map4.png`)">-->
                <!--                    <div>3D地形</div>-->
                <!--                </div>-->
            </div>
        </van-action-sheet>
    </div>
</template>

<script>
import {getQueryVariable, getSkin} from '@/utils/comment'
import {changeDate, formatSeconds, formatSeconds2} from '@/utils/dateUtils'
import BaiduMap from 'vue-baidu-map-v3/components/map/Map.vue'
import mapStyle from '@/assets/theme/light/sport/03challengeDesc/custom_map_config.json'
import mapStyleHide from '@/assets/theme/light/sport/04sportDesc/custom_map_config_hide.json'
import {GPS_transformation, rgbToHsb, hsbToRgb, hexToRgb, rgbToHex} from '@/utils/gpsToBD'
import {Toast} from 'vant';

export default {
    name: 'sportDesc',
    components: {
        BaiduMap
    },
    data() {
        return {
            gpsActionShow: false,
            gpsActions: [{name: '导出云迹'}, {name: '发布云迹'}],
            exportShow: false,
            exportGpsActions: [{name: 'KML格式'}, {name: 'GPX格式'}],
            publishShow: false,
            publishName: '',
            pattern: /^[\u4e00-\u9fa5a-zA-Z]{1,10}$/,
            mapStyleShow: false,
            selectMap: 2,
            playTag: false,
            defaultImg: require('@/assets/share/home/noImg.png'),
            userAvatar: '',
            ratio: 1,
            theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
            sportType: getQueryVariable("sportType"),
            id: getQueryVariable("id"),
            startSportTime: getQueryVariable("startSportTime"),
            center: {lng: 116.404269, lat: 39.913385},
            map: '',
            zoom: 3,
            BMap: '',
            is806: 0,
            noWatchName: 0,
            activeType: 0,
            sportInfo: {},
            watchImg: '',
            watchName: '',
            formatStartTime: '',
            triathlonFormatStartTime: '',
            runTotalShow: false, // 跑步、马拉松、健走、徒步越野、室内跑、登山、越野跑为true
            swimTotalShow: false, // 室内游泳
            rideTotalShow: false, // 骑行
            powerTotalShow: false, // 计次的力量训练
            powerTimeTotalShow: false, // 不计次的力量训练
            triathlonTotalShow: false, // 铁人三项
            skiTotalShow: false, // 滑雪登山
            indoorclimbTotalShow: false, // 室内攀岩
            ballTotalShow: false, // 羽毛球、乒乓球、
            paTotalShow: false, // 爬楼
            otherTotalShow: false, // 其他运动显示卡路里
            hwpyTotalShow: false, // 户外攀岩
            pandengTotalShow: false, // 攀登
            xiajiangTotalShow: false, // 下降
            gpsBoxShow: false, // gpsBox是否显示
            paceTotalShow: false, // 配速统计栏
            speedTotalShow: false, // 速度统计栏
            swimPaceTotalShow: false, // 百米泳速统计栏
            heightTotalShow: false, //海拔统计栏
            stepTotalShow: false, // 步频统计栏
            swolfTotalShow: false, // swolf统计栏
            frequencyTotalShow: false, // 频率统计栏
            hRangeData: [0, 0, 0, 0, 0],
            hRangeDataTime: [0, 0, 0, 0, 0],
            hRangeZoneData: [95, 114, 133, 152, 171],
            paceMath: ['--', '--', '--'], // 最大、最小、平均值
            speedMath: ['--', '--', '--'], // 最大、最小、平均值
            heightMath: ['--', '--', '--'],
            hrMath: ['--', '--', '--'],
            stepMath: ['--', '--', '--'],
            avgStride: '--',
            hrChartShow: false,
            paceChartShow: false,
            speedChartShow: false,
            speedUnit: '米/小时',
            swimChartShow: false,
            stepChartShow: false,
            hxplChartShow: false, // 呼吸频率
            heightChartShow: false,
            lapsShow: false,
            lapsName: '', // 计圈数据 or 计组数据
            lapsDistance: '', // 806每圈距离
            lapsTitle: [], // 计组标题
            lapsData: [], // 每组数据
            lapsGpsLabel: [], // 轨迹图上的圈数
            showLapsGpsTag: 1, // 显示地图上的圈数标志
            triathlon: {}, // 铁人三项信息
            triathlonItem: 0, // 铁人三项当前tab栏 0-游泳；1-骑行；2-跑步
            showExport: false,
            restTime: 0, // 力量训练休息时间
            FullScreen: false, // 是否全屏
            huwaipanyan: {}, // 户外攀岩信息
            subId: [], // 阶段id
            subTitle: [],
            aerRate: 0, // 有氧效果
            anaerRate: 0, //无氧效果
            aerModel: 0, // 有氧效果
            anaerModel: 0, //无氧效果
            sportTypeImg: '', //无GPS时图片
            hwpyItem: '',
            hwpyIndex: 0,
            hwpyList: [],
            showHwpyBox: 0,
            fixedBgShow: false,
            gpsLineList: [],
            gpsColorList: [],
        }
    },
    watch: {
        showHwpyBox: {
            handler(newVal, olVal) {
                if (newVal) {
                    setTimeout(() => {
                        document.addEventListener('click', this.checkClick);
                    }, 0);
                } else {
                    document.removeEventListener('click', this.checkClick);
                }
            }
        }
    },
    mounted() {
        this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
        document.documentElement.setAttribute("theme", this.theme);
        this.id = this.$route.query.id;
        this.sportType = this.$route.query.sportType;
        this.startSportTime = this.$route.query.startSportTime;
        this.userAvatar = this.$route.query.userAvatar;
        if (this.$route.query.token) {
            localStorage.setItem("token", this.$route.query.token);
        }
        this.getData();
        window.addEventListener('scroll', this.windowScroll);
    },
    methods: {
        back() {
            if (this.hwpyItem) {
                location.reload();
            } else {
                WebJSBridge.call("closeWeb", null, function (res) {
                });
            }
        },
        getData() {
            this.$api.sport.getSportDataDetail({
                id: this.id,
                sportType: this.sportType,
                startSportTime: this.startSportTime
            }).then(res => {
                if (res.info.watchName) {
                    if (res.info.watchName.indexOf("TA8") != -1) {
                        this.is806 = 1;
                    }
                } else {
                    this.is806 = 1;
                }

                if (this.sportType == '铁人三项') {
                    this.triathlon = res.info;
                    this.dealTriathlonInfo();
                } else if (this.sportType == '户外攀岩') {
                    this.sportInfo = res.info;
                    this.dealHwpyInfo();
                } else {
                    this.sportInfo = res.info;
                    this.dealSportInfo();
                }
                this.aerRate = this.sportInfo.aerobicEffect / 60 * 100;
                this.anaerRate = this.sportInfo.anaerobicEffect / 60 * 100;
                this.getStartSportTime(res.info.startSportTime);
            })
        },
        // 处理铁人三项数据
        dealTriathlonInfo() {
            this.triathlonTotalShow = true
            let allCal = this.triathlon.swim.calories;
            let allActTime = this.triathlon.swimDuration;
            let allDistance = this.triathlon.swim.distance;
            if (this.triathlon.ride) {
                allCal += parseInt(this.triathlon.ride.calories);
                allDistance += this.triathlon.ride.distance;
                allActTime += this.triathlon.rideDuration;
            }
            if (this.triathlon.run) {
                allCal += parseInt(this.triathlon.run.calories);
                allDistance += this.triathlon.run.distance;
                allActTime += this.triathlon.runDuration;
            }
            this.triathlon.calories = allCal;
            this.triathlon.actTime = allActTime;
            this.triathlon.distance = allDistance;
            this.changeTriathlon(0);
        },
        changeTriathlon(tag) {
            this.runTotalShow = false; // 跑步、马拉松、健走、徒步越野、室内跑、登山、越野跑为true
            this.swimTotalShow = false; // 室内游泳
            this.rideTotalShow = false; // 骑行
            this.ballTotalShow = false;
            this.paTotalShow = false;
            this.otherTotalShow = false;
            this.gpsBoxShow = false; // gpsBox是否显示
            this.paceTotalShow = false; // 配速统计栏
            this.swimPaceTotalShow = false; // 百米泳速统计栏
            this.heightTotalShow = false; //海拔统计栏
            this.stepTotalShow = false; // 步频统计栏
            this.swolfTotalShow = false; // swolf统计栏
            this.paceChartShow = false;
            this.speedChartShow = false;
            this.swimChartShow = false;
            this.stepChartShow = false;
            this.hxplChartShow = false;
            this.heightChartShow = false;
            this.lapsShow = false;
            switch (tag) {
                case 0:
                    this.sportInfo = this.triathlon.swim;
                    this.sportInfo.sportType = '游泳';
                    break;
                case 1:
                    this.sportInfo = this.triathlon.ride;
                    this.sportInfo.sportType = '骑行';
                    break;
                case 2:
                    this.sportInfo = this.triathlon.run;
                    this.sportInfo.sportType = '跑步';
                    break;
            }
            this.getTriathonFormatTime(this.sportInfo);
            this.dealSportInfo();
            this.getSportImg();
        },
        // 处理户外攀岩数据
        dealHwpyInfo() {
            this.hwpyTotalShow = true;
            this.dealSportInfo();
            this.subId = this.sportInfo.lapsId.split(",");
            let lapsState = this.sportInfo.lapsState.split(",");
            let lapsStage = this.sportInfo.lapsStage.split(",");
            this.subTitle = [{title: '综合', id: this.sportInfo.id}];
            for (let i = 0; i < lapsState.length; i++) {
                if (lapsState[i] == 0) {
                    this.subTitle.push({type: lapsState[i], title: '攀登' + lapsStage[i], id: this.subId[i]})
                } else {
                    this.subTitle.push({type: lapsState[i], title: '下撤' + lapsStage[i], id: this.subId[i]})
                }
            }
        },
        // 处理运动数据
        dealSportInfo() {
            this.getWatchType(this.sportInfo.watchName);
            this.dealTotalBoxShow();

            this.checkGpsShow();

            if (this.sportInfo.stepCount && this.sportInfo.distance) {
                this.avgStride = (Math.floor(this.sportInfo.distance / this.sportInfo.stepCount) / 100).toFixed(2);
            }
            if (this.sportInfo.heartrateData) {
                this.dealChartInfo(this.sportInfo.heartrateData, '心率');
            }
            if (this.sportInfo.respiratoryRate) {
                this.dealChartInfo(this.sportInfo.respiratoryRate, '呼吸频率');
            }
            if (this.sportInfo.speedData) {
                if (this.sportInfo.sportType.indexOf('泳') != -1) {
                    this.swolfTotalShow = true;
                    if (this.is806) {
                        this.sportInfo.avgSwolf = parseInt(this.sportInfo.avgSwolf / 10)
                        this.sportInfo.maxSwolf = parseInt(this.sportInfo.maxSwolf / 10)
                    }
                    this.dealChartInfo(this.sportInfo.speedData, '泳速');
                } else if (this.sportInfo.sportType == '登山') {
                    if (this.is806) {
                        this.dealChartInfo(this.sportInfo.speedData, '速度');
                    } else {
                        this.dealChartInfo(this.sportInfo.speedData, '配速');
                    }
                } else if (this.sportInfo.sportType == '滑雪登山' || this.sportInfo.sportType == '骑行') {
                    this.dealChartInfo(this.sportInfo.speedData, '速度');
                } else {
                    this.dealChartInfo(this.sportInfo.speedData, '配速');
                }

            }

            if (this.sportInfo.stepData && this.sportInfo.sportType != '滑雪登山') {
                this.dealChartInfo(this.sportInfo.stepData, '步频');
            }

            if (this.sportInfo.pressureData) {
                if (!this.is806 || (this.is806 && (this.sportInfo.sportType != '室内跑' && this.sportInfo.sportType == '室内游泳' && this.sportInfo.sportType == '游泳'))) {
                    this.dealChartInfo(this.sportInfo.pressureData, '海拔');
                }

            }

            if (this.sportInfo.heartrateRangeData) {
                // if (this.sportInfo.sportType == '室内游泳') {
                this.hRangeData = [];
                this.hRangeDataTime = [];
                let hrr = this.sportInfo.heartrateRangeData.split(',');
                if (this.sportInfo.heartrateRangeZoneData) {
                    this.hRangeZoneData = this.sportInfo.heartrateRangeZoneData.split(',');
                }
                for (let i = 0; i < hrr.length; i++) {
                    this.hRangeData.push(parseInt(parseInt(hrr[i]) / this.sportInfo.actTime * 100));
                    if (hrr[i] == 0) {
                        this.hRangeDataTime.push('00:00:00')
                    } else {
                        this.hRangeDataTime.push(formatSeconds2(hrr[i]))
                    }
                }
                // } else {
                //     this.hRangeData = [];
                //     let hrr = this.sportInfo.heartrateRangeData.split(',');
                //     let all = hrr.reduce((total, current) => total + parseInt(current), 0)
                //     if (all > 0) {
                //         for (let i = 0; i < hrr.length; i++) {
                //             this.hRangeData.push(parseInt(parseInt(hrr[i]) / all * 100));
                //         }
                //     }
                // }
            }
            if ((this.sportInfo.lapsData || this.sportInfo.lapsPace || this.sportInfo.lapsId) && !this.xiajiangTotalShow) {
                this.dealLaps();
            }
        },
        // 第一行总数据显示
        dealTotalBoxShow() {
            switch (this.sportInfo.sportType) {
                case "跑步":
                case "马拉松":
                case "健走":
                case "徒步越野":
                case "登山":
                case "越野跑":
                case "室内跑":
                case "操场跑":
                case "冲浪":
                case "帆板":
                case "飞盘":
                case "轮滑":
                case "骑马":
                case "越野滑雪":
                case "足球":
                case "滑雪登山":
                case "跳伞":
                    this.runTotalShow = true;
                    break;
                case "室内游泳":
                case "游泳":
                case "户外游泳":
                case "皮划艇":
                    this.swimTotalShow = true;
                    break;
                case "骑行":
                case "越野骑行":
                    this.rideTotalShow = true;
                    break;
                case "俯卧撑":
                case "深蹲":
                case "卷腹":
                case "椭圆机":
                case "划船机":
                case "跳绳":
                case "自由训练":
                case "平板支撑":
                    this.powerTotalShow = true;
                    break;
                case "室内攀岩":
                    this.indoorclimbTotalShow = true;
                case "乒乓球":
                case "羽毛球":
                case "网球":
                    this.ballTotalShow = true;
                case "爬楼":
                    this.paTotalShow = true;
                default:
                    this.otherTotalShow = true;
            }
            if (this.sportInfo.sportType == '跳绳') {
                this.frequencyTotalShow = true;
            }
            this.getSportImg();
        },
        getSportImg() {
            switch (this.sportInfo.sportType) {
                case "深蹲":
                case "俯卧撑":
                case "卷腹":
                case "引体向上":
                case "平板支撑":
                case "自由训练":
                case "飞鸟":
                    this.sportTypeImg = '力量训练';
                    break;
                case "铁人三项游泳":
                case "游泳":
                    this.sportTypeImg = '室内游泳';
                    break;
                default:
                    this.sportTypeImg = this.sportType;
                    break;
            }
        },
        getSwimPose(pose) {
            switch (pose) {
                case 0:
                    return '自由泳';
                    break;
                case 1:
                    return '仰泳';
                    break;
                case 2:
                    return '蛙泳';
                    break;
                case 3:
                    return '蝶泳';
                    break;
                case 4:
                    return '未知';
                    break;
                case 5:
                    return '混合泳';
                    break;
                default:
                    return '未知泳姿';
                    break;
            }
        },
        checkGpsShow() {
            switch (this.sportInfo.sportType) {
                case "跑步":
                case "马拉松":
                case "健走":
                case "徒步越野":
                case "登山":
                case "越野跑":
                case "骑行":
                case "滑雪登山":
                    this.gpsBoxShow = true;
                    break;
            }
        },
        // 处理图表数据
        dealChartInfo(odata, type) {
            odata = odata.split(',');
            if (odata.length == 0 || this.checkArrValid(odata)) {
                return;
            }
            let timeStep = this.is806 ? 60 : 20;
            let count = Math.floor(this.sportInfo.actTime / timeStep);
            let ndata = [], xData = [];
            let colorGroup = [];
            let chartId;
            if (type == '海拔') {
                if (this.is806) {
                    for (let i = 0; i < count; i++) {
                        let j = Math.floor((i + 1) / 5);
                        let value = 0;
                        if (j >= odata.length) {
                            value = Number(odata[odata.length - 1]);
                        } else {
                            value = Number(odata[j]);
                        }
                        xData.push(formatSeconds2(timeStep * (i + 1)));
                        ndata.push(value);
                    }
                } else {
                    for (let i = 0; i < count; i++) {
                        let value = 0;
                        if (i >= odata.length) {
                            value = Number(odata[odata.length - 1]);
                        } else {
                            value = Number(odata[i]);
                        }
                        xData.push(formatSeconds2(timeStep * (i + 1)));
                        ndata.push(value);
                    }
                }
                colorGroup = [getSkin('--chart-color-1'), getSkin('--bg-color-2'), getSkin('--chart-color-22')];
                chartId = 'height-chart';
                this.heightMath = this.getArrMath(ndata);
                // this.heightMath = [this.sportInfo.maxHeight, this.sportInfo.minHeight, this.sportInfo.avgHeight];
                this.heightTotalShow = true;
                this.heightChartShow = true;
            } else if (type == '心率' || type == '配速' || type == '速度' || type == '泳速') {
                for (let i = 0; i < count; i++) {

                    let value = 0;
                    if (i >= odata.length) {
                        value = Number(odata[odata.length - 1]);
                    } else {
                        value = Number(odata[i]);
                    }
                    xData.push(formatSeconds2(timeStep * (i + 1)));
                    if ((!this.is806) && (type == '配速')) {
                        value = value == 0 ? 0 : 10000 / (value ? value : 1)
                    }
                    if ((!this.is806) && (type == '泳速')) {
                        value = value == 0 ? 0 : 1000 / (value ? value : 1)
                    }

                    if ((this.sportInfo.sportType == '滑雪登山' || this.sportInfo.sportType == '骑行') && (type == '速度')) {
                        value = value == 0 ? 0 : (value * 3.6 / 10).toFixed(1)
                    }

                    if ((this.is806) && (type == '速度')) {
                        value = value / 10;
                    }
                    ndata.push(value);
                }
                if (type == '心率') {
                    colorGroup = [getSkin('--chart-color-3'), getSkin('--bg-color-2'), getSkin('--chart-color-19')];
                    chartId = 'hr-chart';
                    this.hrMath = this.getArrMath(ndata);
                    this.hrChartShow = true;
                } else if (type == '配速') {
                    colorGroup = [getSkin('--chart-color-10'), getSkin('--bg-color-2'), getSkin('--chart-color-20')];
                    chartId = 'pace-chart';
                    let value = this.sportInfo.maxSpeed ? this.sportInfo.maxSpeed : 0;
                    let value1 = this.sportInfo.avgSpeed ? this.sportInfo.avgSpeed : 0;
                    if (!this.is806 && (type == '配速')) {
                        value = value == 0 ? 0 : 10000 / (value ? value : 1);
                        value1 = value1 == 0 ? 0 : 10000 / (value1 ? value1 : 1);
                    }
                    this.paceMath = this.getArrMath(ndata);
                    if (value) {
                        this.paceMath[1] = parseInt(value);
                    }
                    if (value1) {
                        this.paceMath[2] = parseInt(value1);
                    }
                    this.paceTotalShow = true;
                    this.paceChartShow = true;
                } else if (type == '速度') {
                    colorGroup = [getSkin('--chart-color-10'), getSkin('--bg-color-2'), getSkin('--chart-color-20')];
                    chartId = 'speed-chart';
                    this.speedMath = this.getArrMath(ndata);
                    // this.speedMath[2] = (this.sportInfo.avgSpeed / 10).toFixed(1);
                    this.speedTotalShow = true;
                    this.speedChartShow = true;
                    if (this.sportInfo.sportType == '骑行' || this.sportInfo.sportType == '滑雪登山') {
                        this.speedUnit = '公里/小时';
                    }
                } else if (type == '泳速') {
                    colorGroup = [getSkin('--chart-color-10'), getSkin('--bg-color-2'), getSkin('--chart-color-20')];
                    chartId = 'swim-chart';
                    let value = this.sportInfo.maxSpeed ? this.sportInfo.maxSpeed : 0;
                    let value1 = this.sportInfo.avgSpeed ? this.sportInfo.avgSpeed : 0;
                    if ((!this.is806) && (type == '泳速')) {
                        value = value == 0 ? 0 : 1000 / (value ? value : 1);
                        value1 = value1 == 0 ? 0 : 1000 / (value1 ? value1 : 1)
                    }
                    this.paceMath = this.getArrMath(ndata);
                    if (value) {
                        this.paceMath[1] = parseInt(value);
                    }
                    if (value1) {
                        this.paceMath[2] = parseInt(value1);
                    }
                    this.swimPaceTotalShow = true;
                    this.swimChartShow = true;
                }
            } else if (type == '步频') {
                let lastAccumulative = 0, currentAccumulative = 0;
                for (let i = 0; i < odata.length; i++) {
                    if (i == 0) {
                        lastAccumulative = parseInt(odata[i]);
                        ndata.push(lastAccumulative);
                    } else {
                        if (odata[i] < lastAccumulative) {
                            currentAccumulative = parseInt(odata[i]) + lastAccumulative;
                        } else {
                            currentAccumulative = parseInt(odata[i]);
                        }
                        ndata.push(currentAccumulative - lastAccumulative);
                        lastAccumulative = currentAccumulative;
                    }
                    let s = (i + 1) * 60;
                    xData.push(formatSeconds2(s));
                }
                // }
                colorGroup = [getSkin('--chart-color-3'), getSkin('--bg-color-2'), getSkin('--chart-color-21')];
                chartId = 'step-chart';
                this.stepMath = this.getArrMath(ndata);
                this.stepMath[2] = parseInt(this.sportInfo.stepCount / this.sportInfo.actTime * 60);
                this.stepTotalShow = true;
                this.stepChartShow = true;
            } else if (type == '呼吸频率') {
                let lastAccumulative = 0, currentAccumulative = 0;
                for (let i = 0; i < odata.length; i++) {
                    if (i == 0) {
                        lastAccumulative = parseInt(odata[i]);
                        ndata.push(lastAccumulative);
                    } else {
                        if (odata[i] < lastAccumulative) {
                            currentAccumulative = parseInt(odata[i]) + lastAccumulative;
                        } else {
                            currentAccumulative = parseInt(odata[i]);
                        }
                        ndata.push(currentAccumulative - lastAccumulative);
                        lastAccumulative = currentAccumulative;
                    }
                    let s = (i + 1) * 60;
                    xData.push(formatSeconds2(s));
                }
                // }
                colorGroup = [getSkin('--chart-color-3'), getSkin('--bg-color-2'), getSkin('--chart-color-21')];
                chartId = 'hxpl-chart';
                this.hxplChartShow = true;
            }

            this.$nextTick(function () {
                this.drawChart(chartId, type, ndata, xData, colorGroup);
            })
        },
        // 画图标
        drawChart(id, type, data, xdata, colorGroup) {
            let yAxis = {
                type: 'value',
                position: 'left',
                splitNumber: 4,
                boundaryGap: [0, '10%'],
                splitLine: {
                    lineStyle: {
                        type: 'dotted',
                        color: getSkin('--line-color-3')
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: getSkin('--text-color-3'),
                    showMinLabel: false,
                    formatter: function (value, index) {
                        if (type == '配速' || type == '泳速') {
                            value = formatSeconds(value);
                        }
                        return value;
                    }
                },
            };
            let interval;

            if (type == '海拔') {
                interval = Math.ceil((this.heightMath[0] - this.heightMath[1]) / 3) > 0 ? Math.ceil((this.heightMath[0] - this.heightMath[1]) / 3) : 1;
                yAxis = {
                    type: 'value',
                    position: 'left',
                    splitNumber: 3,
                    interval: interval,
                    max: this.heightMath[1] + 3 * interval,
                    min: this.heightMath[1],
                    axisLabel: {
                        fontSize: 12,
                        color: getSkin('--text-color-3'),
                        showMinLabel: false,
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dotted',
                            color: getSkin('--line-color-3')
                        }
                    },
                }
            }
            let myChart = this.$echarts.init(document.getElementById(id));
            myChart.setOption({
                grid: {
                    top: 15 * this.ratio,
                    bottom: 35 * this.ratio,
                    left: 53 * this.ratio,
                    right: 26 * this.ratio
                },
                dataZoom: { // 放大和缩放
                    type: 'inside'
                },
                tooltip: {
                    backgroundColor: getSkin('--bg-color-2'),
                    trigger: 'axis',
                    axisPointer: {
                        type: 'line'
                    },
                    formatter: function (params, ticket, callback) {
                        let item = params[0];
                        let html = '';
                        let value;
                        if (item.seriesName == '配速' || item.seriesName == '泳速') {
                            value = formatSeconds(item.data)
                        } else {
                            value = item.data;
                        }
                        html += '<div style="font-size:12px;color: ' + getSkin('--text-color-3') + '">' + item.axisValue + '</div>'
                        html += '<div style="font-size:12px;color: ' + getSkin('--text-color-3') + '">' + item.seriesName + '：<span style="font-size:19px;font-family:PP;color: ' + getSkin('--text-color-1') + '">' + value + '</span></div>'
                        return html
                    }
                },
                xAxis: {
                    type: 'category',
                    axisLine: {
                        lineStyle: {
                            color: getSkin('--line-color-2')
                        }
                    },
                    axisLabel: {
                        fontSize: 12,
                        color: getSkin('--text-color-3'),
                        interval: Math.floor(xdata.length / 2) - 2
                    },
                    axisTick: {
                        show: false
                    },
                    data: xdata
                },
                yAxis: yAxis,
                series: [
                    {
                        data: data,
                        name: type,
                        type: 'line',
                        symbol: 'none',
                        color: colorGroup[0],
                        smooth: true,
                        areaStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 1,
                                    color: colorGroup[1]
                                },
                                {
                                    offset: 0,
                                    color: colorGroup[2]
                                }
                            ])
                        },
                    }
                ]
            }, true);
        },
        // 获取数组最大、最小、平均值
        getArrMath(data) {
            let avg = 0, all = 0, allCount = 0, max = data[0], min = data[0];
            for (let i = 0; i < data.length; i++) {
                if ((data[i] != 0 && data[i] < min) || (data[i] > 0 && min == 0)) {
                    min = data[i];
                }
                if (data[i] > max) {
                    max = data[i];
                }
                if (data[i] != 0) {
                    all += data[i];
                    allCount++;
                }

            }
            avg = Math.floor(all / allCount);
            return [max, min, avg];
        },
        // 判断数组是否全为0
        checkArrValid(arr) {
            let inValid = true;
            for (let i = 0; i < arr.length; i++) {
                if (arr[i] != 0) {
                    inValid = false;
                }
            }
            return inValid;
        },
        // 处理计圈数据
        dealLaps() {
            switch (this.sportInfo.sportType) {
                case "自由训练":
                case "俯卧撑":
                case "深蹲":
                case "卷腹":
                case "平板支撑":
                case "椭圆机":
                case "划船机":
                case "跳绳":
                    this.initGroupData();
                    break;
                default:
                    this.initCircleData();
                    break;
            }
        },
        getRestTime() {
            let startTime = new Date(this.sportInfo.startSportTime.replace(/[-]/g, "/"));
            let endTime = new Date(this.sportInfo.endSportTime.replace(/[-]/g, "/"));
            let allTime = (endTime - startTime) / 1000;
            this.restTime = allTime - this.sportInfo.actTime;
        },
        // 力量训练组数
        initGroupData() {
            this.lapsName = '计组数据';
            // 计算休息时间
            this.getRestTime();
            switch (this.sportInfo.sportType) {
                case "自由训练":
                case "平板支撑":
                    this.lapsTitle = ['组数', '时长', '负重'];
                    let lapsData = this.sportInfo.lapsData.split(',');
                    let lapsWeight = this.sportInfo.lapsWeight.split(',');
                    for (let i = 0; i < lapsData.length; i++) {
                        this.lapsData.push([i + 1, formatSeconds2(lapsData[i]), lapsWeight[i]]);
                    }
                    break;
                case "俯卧撑":
                case "深蹲":
                case "卷腹":
                    this.lapsTitle = ['组数', '次数', '时长', '负重'];
                    let lapsNum1 = this.sportInfo.lapsCountNum.split(',');
                    let lapsData1 = this.sportInfo.lapsData.split(',');
                    let lapsWeight1 = this.sportInfo.lapsWeight.split(',');
                    for (let i = 0; i < lapsData1.length; i++) {
                        this.lapsData.push([i + 1, lapsNum1[i], formatSeconds2(lapsData1[i]), lapsWeight1[i]]);
                    }
                    break;
                case "椭圆机":
                    this.lapsTitle = ['组数', '时长'];
                    let lapsData2 = this.sportInfo.lapsData.split(',');
                    for (let i = 0; i < lapsData2.length; i++) {
                        this.lapsData.push([i + 1, formatSeconds2(lapsData2[i])]);
                    }
                    break;
                case "划船机":
                case "跳绳":
                    this.lapsTitle = ['组数', '次数', '时长', '频率'];
                    let lapsNum3 = this.sportInfo.lapsCountNum.split(',');
                    let lapsData3 = this.sportInfo.lapsData.split(',');
                    let lapsFrequency3 = this.sportInfo.lapsFrequency.split(',');
                    for (let i = 0; i < lapsData3.length; i++) {
                        this.lapsData.push([i + 1, lapsNum3[i], formatSeconds2(lapsData3[i]), lapsFrequency3[i]]);
                    }
                    break;
            }
            this.lapsShow = true;
        },
        // 普通运动圈数
        initCircleData() {
            if (this.sportInfo.sportType.indexOf("游泳") != -1) {
                // this.lapsName = '计趟数据';
                // this.lapsTitle = ['趟数','划数', '时间', '百米泳速'];
                // let lapsData = this.sportInfo.lapsData.split(',');
                // let lapsPace = this.sportInfo.lapsPace.split(',');
                // let lapsSwimStroke = this.sportInfo.lapsSwimStroke.split(',');
                // for (let i = 0; i < lapsData.length; i++) {
                //     this.lapsData.push([i + 1,lapsSwimStroke[i], formatSeconds2(lapsData[i]), formatSeconds(lapsPace[i])]);
                // }
                return
            } else {
                if (this.is806) {
                    if (this.sportInfo.sportType == '跑步' || this.sportInfo.sportType == '马拉松') {
                        this.lapsName = '各圈配速';
                        let circleDistance = this.sportInfo.lapsDistance;
                        this.lapsDistance = (circleDistance / 1000).toFixed(1) + '公里/圈'
                        this.lapsTitle = ['圈数', '配速', '累计耗时'];
                        let lapsData = this.sportInfo.lapsData.split(',');
                        let afterPace = 0;
                        for (let i = 0; i < lapsData.length; i++) {
                            let time = 0;
                            if (lapsData[i] > afterPace) {
                                time = parseInt(lapsData[i]) - afterPace;
                                afterPace = parseInt(lapsData[i]);
                            } else {
                                time = parseInt(lapsData[i]);
                                afterPace += parseInt(lapsData[i]);
                            }
                            let dis = circleDistance / 1000;
                            let pace = parseInt(time / dis);
                            this.lapsData.push([i + 1, formatSeconds(pace), formatSeconds2(afterPace)]);
                        }
                        let lastDistance = (this.sportInfo.distance / 100000 - lapsData.length * (circleDistance / 1000)).toFixed(2);
                        if (lastDistance > 0) {
                            this.lapsData.push([lapsData.length + 1, lastDistance + "公里", formatSeconds2(this.sportInfo.actTime)]);
                        }
                    } else {
                        this.lapsName = '各圈速度';
                        let circleDistance = this.sportInfo.lapsDistance;
                        this.lapsDistance = (circleDistance / 1000).toFixed(1) + '公里/圈'
                        this.lapsTitle = ['圈数', '速度', '累计耗时'];
                        let lapsData = this.sportInfo.lapsData.split(',');
                        let afterPace = 0;
                        for (let i = 0; i < lapsData.length; i++) {
                            let time = 0;
                            if (lapsData[i] > afterPace) {
                                time = parseInt(lapsData[i]) - afterPace;
                                afterPace = parseInt(lapsData[i]);
                            } else {
                                time = parseInt(lapsData[i]);
                                afterPace += parseInt(lapsData[i]);
                            }
                            let dis = circleDistance / 1000;
                            let pace = (dis / time * 3600).toFixed(1);
                            this.lapsData.push([i + 1, pace, formatSeconds2(afterPace)]);
                        }
                        let lastDistance = (this.sportInfo.distance / 100000 - lapsData.length * (circleDistance / 1000)).toFixed(2);
                        if (lastDistance > 0) {
                            this.lapsData.push([lapsData.length + 1, lastDistance + "公里", formatSeconds2(this.sportInfo.actTime)]);
                        }
                    }
                    this.lapsShow = true;
                } else {
                    if (this.sportInfo.sportType == '滑雪登山') {
                        this.lapsName = '阶段数据';
                        this.lapsTitle = ['', '阶段', '时长', '速度', '爬升/下降'];
                        let lapsNum4 = this.sportInfo.lapsNum;
                        let lapsStage = this.sportInfo.lapsStage.split(',');
                        let lapsState = this.sportInfo.lapsState.split(',');
                        let lapsDuration = this.sportInfo.lapsData.split(',');
                        let lapsPace = this.sportInfo.lapsPace.split(',');
                        let lapsHeight = this.sportInfo.lapsHeight.split(',');
                        for (let i = 0; i < lapsNum4; i++) {
                            this.lapsData.push([lapsState[i], lapsStage[i], formatSeconds2(lapsDuration[i]), (lapsPace[i] / 100).toFixed(2), lapsHeight[i]]);
                        }
                        this.lapsShow = true;
                    } else if (this.sportInfo.sportType == '室内攀岩') {
                        this.lapsName = '路线数据';
                        this.lapsTitle = ['路线', '时长', '难度', '坠落'];
                        let lapsNum4 = this.sportInfo.lapsNum;
                        let lapsComplete = this.sportInfo.lapsComplete.split(',');
                        let lapsDuration = this.sportInfo.lapsData.split(',');
                        let lapsDifficulty = this.sportInfo.lapsDifficulty.split(',');
                        let lapsClimb = this.sportInfo.lapsClimb.split(',');
                        let lapsFall = this.sportInfo.lapsFall.split(',');
                        for (let i = 0; i < lapsNum4; i++) {
                            let num = i + 1;
                            this.lapsData.push([[num, lapsComplete[i]], formatSeconds2(lapsDuration[i]), lapsDifficulty[i], lapsFall[i]]);
                        }
                        this.lapsShow = true;
                    } else if (this.sportInfo.sportType == '户外攀岩') {
                        if (!this.hwpyItem) {
                            this.lapsName = '攀登数据';
                            this.lapsTitle = ['阶段', '距离', '时长', '操作'];
                            let lapsId = this.sportInfo.lapsId.split(',');
                            let lapsStage = this.sportInfo.lapsStage.split(',');
                            let lapsState = this.sportInfo.lapsState.split(',');
                            let lapsDistanceData = this.sportInfo.lapsDistanceData.split(',');
                            let lapsData = this.sportInfo.lapsData.split(',');
                            this.hwpyList = [];
                            for (let i = 0; i < lapsId.length; i++) {
                                this.lapsData.push([[lapsStage[i], lapsState[i]], lapsDistanceData[i], formatSeconds2(lapsData[i]), lapsId[i]]);
                                this.hwpyList.push({
                                    title: lapsState[i] == 1 ? '下撤' + lapsStage[i] : '攀登' + lapsStage[i],
                                    id: lapsId[i],
                                    lapsState: lapsState[i]
                                });
                            }
                            this.lapsShow = true;
                        } else if (this.hwpyItem.lapsState == 0) {
                            this.lapsName = '攀登数据';
                            this.lapsTitle = ['', '时长', '难度', '绳距'];
                            let lapsNum4 = this.sportInfo.lapsNum;
                            let lapsRopeDistance = this.sportInfo.lapsRopeDistance.split(',');
                            let lapsDuration = this.sportInfo.lapsData.split(',');
                            let lapsDifficulty = this.sportInfo.lapsDifficulty.split(',');
                            for (let i = 0; i < lapsNum4; i++) {
                                let num = i + 1;
                                this.lapsData.push([num, formatSeconds2(lapsDuration[i]), lapsDifficulty[i], lapsRopeDistance[i]]);
                            }
                            this.lapsShow = true;
                        }
                    } else if (this.sportInfo.sportType == '骑行') {
                        this.lapsName = '计圈数据';
                        this.lapsTitle = ['圈数', '距离', '时长', '速度'];
                        let lapsData = this.sportInfo.lapsData.split(',');
                        let lapsPace = this.sportInfo.lapsPace.split(',');
                        let lapsDistanceData = this.sportInfo.lapsDistanceData.split(',');
                        for (let i = 0; i < lapsData.length; i++) {
                            this.lapsData.push([i + 1, (lapsDistanceData[i] / 100000).toFixed(2), formatSeconds2(lapsData[i]), (3600 / lapsPace[i]).toFixed(2)]);
                        }
                        this.lapsShow = true;
                    } else {
                        this.lapsName = '计圈数据';
                        this.lapsTitle = ['圈数', '距离', '时长', '配速'];
                        let lapsData = this.sportInfo.lapsData.split(',');
                        let lapsPace = this.sportInfo.lapsPace.split(',');
                        let lapsDistanceData = this.sportInfo.lapsDistanceData.split(',');
                        for (let i = 0; i < lapsData.length; i++) {
                            this.lapsData.push([i + 1, (lapsDistanceData[i] / 100000).toFixed(2), formatSeconds2(lapsData[i]), formatSeconds(lapsPace[i])]);
                        }
                        this.lapsShow = true;
                    }
                }
            }
        },
        // 地图初始化
        initMap({BMap, map}) {
            map.setMapStyleV2({
                styleJson: mapStyle
            })
            this.map = map;
            this.BMap = BMap;
            this.drawGps();
        },
        drawGps() {
            let point = this.sportInfo.gpsData;
            let pointArr = point.split(',');
            if (pointArr.length < 4) {
                this.sportInfo.gpsData = '';
            }
            let lineList = []; // 点数组
            let distanceList = []; // 距离数组
            for (let i = 0; i < pointArr.length - 1; i = i + 2) {
                if (Math.abs(pointArr[i]) < 180 && Math.abs(pointArr[i + 1]) < 75 && pointArr[i] != 0 && pointArr[i + 1] != 0) {
                    if (lineList.length > 0) {
                        if (Math.abs(lineList[lineList.length - 1].lng - pointArr[i]) < 10 && Math.abs(lineList[lineList.length - 1].lat - pointArr[i + 1])) {
                            let bd = GPS_transformation(Number(pointArr[i + 1]), Number(pointArr[i]));
                            let bpPoint = new this.BMap.Point(bd[0], bd[1]);
                            lineList.push(bpPoint);
                        }
                    } else {
                        let bd = GPS_transformation(Number(pointArr[i + 1]), Number(pointArr[i]));
                        let bpPoint = new this.BMap.Point(bd[0], bd[1]);
                        lineList.push(bpPoint);
                    }
                }
            }
            for (let i = 1; i < lineList.length; i++) {
                distanceList.push(this.map.getDistance(lineList[i - 1], lineList[i]))
            }
            let maxDistance = parseFloat(Math.max(...distanceList));
            let minDistance = parseFloat(Math.min(...distanceList));
            // 距离差
            let diffDistance = maxDistance - minDistance;

            // 起始色相和终止色相
            const startColorHsb = [236, 82, 59]
            const endColorHsb = [0, 82, 59]
            //色相差
            const diffHue = endColorHsb[0] - startColorHsb[0]

            // 最小色相
            const minHue = startColorHsb[0]
            // 生成整段路线的颜色列表

            const colorList = distanceList.map((distance, index) => {
                // 当前色相
                const hue = minHue + ((distance - minDistance) * diffHue) / diffDistance
                // 颜色
                return rgbToHex(hsbToRgb(...[hue, startColorHsb[1], startColorHsb[2]]))
            })
            this.gpsColorList = colorList;
            lineList = this.getKalmanData(lineList);
            for (let i = 1; i < lineList.length; i++) {
                let line = lineList.slice(i - 1, i + 1)
                var polyline = new this.BMap.Polyline(line,
                    {strokeColor: '#2ECF6C', strokeWeight: 8, strokeOpacity: 1});
                this.map.addOverlay(polyline);
            }
            this.gpsLineList = lineList
            let view = this.map.getViewport(eval(this.gpsLineList));
            this.zoom = view.zoom;
            this.center = view.center;

            let startIcon = new this.BMap.Icon(require("@/assets/theme/" + this.theme + "/sport/04sportDesc/12start.svg"), new this.BMap.Size(21, 28), {
                imageSize: new this.BMap.Size(21, 28),
                imageOffset: new this.BMap.Size(0, 0)
            });
            let startMarker = new this.BMap.Marker(lineList[0], {icon: startIcon}) // 创建标注
            this.map.addOverlay(startMarker)

            let endIcon = new this.BMap.Icon(require("@/assets/theme/" + this.theme + "/sport/04sportDesc/13end.svg"), new this.BMap.Size(19, 26), {
                imageSize: new this.BMap.Size(19, 26),
                imageOffset: new this.BMap.Size(0, 0)
            });
            let endMarker = new this.BMap.Marker(lineList[lineList.length - 1], {icon: endIcon}) // 创建标注
            this.map.addOverlay(endMarker);
            this.showMapLaps();
        },
        // 卡尔曼滤波
        getKalmanData(points) {
            let result = [];
            let lat_Z = 0;
            let lat_P = 0;
            let lon_Z = 0;
            let lon_P = 0;
            for (let i = 0; i < points.length; i++) {
                let point = points[i];
                if (lat_Z == 0) {
                    lat_Z = point.lat;
                    lon_Z = point.lng;
                }
                let latparam = this.KalmanFilter(point.lat, lat_Z, lat_P);
                lat_P = latparam[1];
                lat_Z = latparam[0];
                let lonparam = this.KalmanFilter(point.lng, lon_Z, lon_P)
                lon_P = lonparam[1];
                lon_Z = lonparam[0];
                var npoint = new this.BMap.Point(lon_Z, lat_Z);
                result.push(npoint);
            }
            return result;
        },
        KalmanFilter(T, Z, P) {
            let Q = 0.000001;
            let R = 0.000001;
            var P1 = Math.hypot(P, Q)
            let K = (Math.pow(P1, 2) / (Math.pow(P1, 2) + Math.pow(R, 2)))
            let Z1 = (Z + K * (T - Z))  //更新状态估计
            P1 = Math.sqrt((1 - K) * Math.pow(P1, 2))  //更新协方差估计
            return [Z1, P1];
        },
        getWatchType(type) {
            if (type.indexOf('TA7') != -1) {
                type = type.substring(0, 6)
            } else {
                type = type.substring(0, 3)
            }
            this.watchImg = type;
            switch (type) {
                case "TA8":
                    this.watchName = 'Syntime1';
                    return;
                case "TA9":
                    this.watchName = 'Syntime2';
                    return;
                case "TA2":
                    this.watchName = 'Syntime3';
                    return;
                case "TA6":
                    this.watchName = 'Astrolink';
                    return;
                case "TA700S":
                    this.watchName = 'Astrolink S';
                    return;
                case "TA700G":
                    this.watchName = 'Astrolink G';
                    return;
                default:
                    this.noWatchName = 1
            }
        },
        getStartSportTime(time) {
            let date = changeDate(time);
            let hour = time.substring(10, 16);
            this.formatStartTime = date + hour;
            if (this.sportType == '滑雪登山' || this.sportType == '户外攀岩') {
                this.getRestTime();
            }
        },
        getTriathonFormatTime(info) {
            let date = changeDate(info.startSportTime);
            let hour1 = info.startSportTime.substring(10, 16);
            let hour2 = info.endSportTime.substring(10, 16);
            this.triathlonFormatStartTime = date + hour1 + '~' + hour2;
        },
        formatSeconds2(num) {
            return formatSeconds2(num)
        },
        formatSeconds(num) {
            if (num == '--') {
                return '--'
            } else {
                return formatSeconds(num)
            }
        },
        showMapLaps() {
            this.showLapsGpsTag = 1;
            for (let i = 0; i < this.lapsGpsLabel.length; i++) {
                this.map.removeOverlay(this.lapsGpsLabel[i]);
            }
            this.lapsGpsLabel = [];
            if (this.sportInfo.lapsGpsData) {
                let lapsGpsArr = this.sportInfo.lapsGpsData.split(',');
                let gpsArr = [];
                for (let i = 0; i < lapsGpsArr.length - 1; i = i + 2) {
                    gpsArr.push([lapsGpsArr[i], lapsGpsArr[i + 1]]);
                }
                for (let i = 0; i < gpsArr.length; i++) {
                    let a = GPS_transformation(gpsArr[i][1], gpsArr[i][0]);
                    var point = new this.BMap.Point(a[0], a[1]);
                    var label = new this.BMap.Label(i + 1, {       // 创建文本标注
                        position: point,
                        offset: new this.BMap.Size(-8, -8)
                    })
                    this.map.addOverlay(label);                        // 将标注添加到地图中
                    label.setStyle({                              // 设置label的样式
                        color: '#fff',
                        fontSize: '10px',
                        border: '2px solid #fff',
                        width: '12px',
                        height: '12px',
                        lineHeight: '12px',
                        textAlign: 'center',
                        background: '#000',
                        borderRadius: '50%'
                    })
                    this.lapsGpsLabel.push(label);
                }
            }
        },
        hideMapLaps() {
            this.showLapsGpsTag = 0;
            for (let i = 0; i < this.lapsGpsLabel.length; i++) {
                this.map.removeOverlay(this.lapsGpsLabel[i]);
            }
        },
        showHistory() {
            this.nowPlanShow = false;
            this.$api.active.getHistory().then((res) => {
                this.historyList = res.info;
                for (let i = 0; i < this.historyList.length; i++) {
                    this.historyList[i].planBegin = this.historyList[i].planBegin.replace(/[-]/g, "/");
                    this.historyList[i].planEnd = this.historyList[i].planEnd.replace(/[-]/g, "/");
                }
            })
        },
        getEffectLevel(num) {
            if (num <= 10) {
                return '【无效果】';
            } else if (num <= 20) {
                return '【恢复】';
            } else if (num <= 30) {
                return '【维持】';
            } else if (num <= 40) {
                return '【改善】';
            } else if (num <= 50) {
                return '【增强】';
            } else if (num <= 60) {
                return '【运动过度】';
            }
        },
        getSpeed(num) {
            if (this.is806) {

            } else {
                return (num * 3.6 / 10).toFixed(2)
            }
            return (num * 3.6 / 10).toFixed(2)
        },
        toHwpy(item, index) {
            this.showHwpyBox = 0
            this.lapsShow = false;
            this.lapsName = '';
            this.lapsTitle = [];
            this.lapsData = [];
            this.hwpyItem = item
            this.hwpyIndex = index;
            this.$api.sport.getOutDoorClimbDes({id: item.id}).then(res => {
                this.sportInfo = res.info
                this.dealSportInfo();
            })
        },
        checkClick(event) {
            let dom = this.$refs.showContent; // 这里是你的下拉菜单元素
            if (!dom.contains(event.target)) {
                // 不在菜单范围，隐藏即可
                if (this.showHwpyBox) {
                    this.showHwpyBox = 0;
                    document.removeEventListener('click', this.checkClick);
                }
            }
        },
        selectGpsAction(action, index) {
            if (index == 0) {
                this.exportShow = true;
            } else {
                this.publishShow = true;
                this.publishName = this.sportType;
            }
        },
        selectExportAction(action, index) {

        },
        sendPublish() {
            if (this.publishName) {
                this.$api.sport.publish({
                    moveType: this.sportInfo.sportType,
                    averMatchSpeed: this.sportInfo.avgSpeed,
                    city: this.sportInfo.city,
                    district: this.sportInfo.district,
                    locateAddr: this.sportInfo.address,
                    locusDistance: this.sportInfo.distance,
                    locusName: this.publishName,
                    province: this.sportInfo.province,
                    startTime: this.sportInfo.startSportTime,
                    status: 1,
                    timeLength: this.sportInfo.actTime,
                    trackPosition: this.sportInfo.gpsData,
                }).then(res => {
                    this.publishName = '';
                    Toast.success('发布成功');
                    this.publishShow = false;
                })
            } else {
                this.publishShow = true
            }
        },
        onBeforeClose(action, done) {
            // 点击了确定按钮
            if (action === "confirm") {
                if (this.pattern.test(this.publishName)) {
                    this.sendPublish();
                } else {
                    return done(false);
                }
            }
            // 点击了取消按钮
            else {
                done(true); //关闭弹窗, true可以省略
            }
        },
        windowScroll() {
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop > 88 * this.ratio) {
                this.fixedBgShow = true;
            } else {
                this.fixedBgShow = false;
            }
        },
        confirmMapStype() {
            if (this.selectMap == 1) {
                this.map.setMapStyleV2({
                    styleJson: mapStyleHide
                })
            } else if (this.selectMap == 2) {
                this.map.setMapStyleV2({
                    styleJson: mapStyle
                })
                this.map.setMapType(BMAP_NORMAL_MAP);
            } else if (this.selectMap == 3) {
                this.map.setMapType(BMAP_SATELLITE_MAP);
            }
        },
        playGps() {
            this.playTag = true;
            let view = this.map.getViewport(eval(this.gpsLineList));
            this.zoom = view.zoom;
            this.center = view.center;
            this.map.centerAndZoom(this.center, this.zoom);
            this.map.clearOverlays();
            let startIcon = new this.BMap.Icon(require("@/assets/theme/" + this.theme + "/sport/04sportDesc/12start.svg"), new this.BMap.Size(21, 28), {
                imageSize: new this.BMap.Size(21, 28),
                imageOffset: new this.BMap.Size(0, 0)
            });
            let startMarker = new this.BMap.Marker(this.gpsLineList[0], {icon: startIcon}) // 创建标注
            this.map.addOverlay(startMarker);
            let _this = this;
            let playIcon = new this.BMap.Icon(require("@/assets/theme/" + this.theme + "/sport/04sportDesc/13end.svg"), new this.BMap.Size(19, 26), {
                imageSize: new this.BMap.Size(19, 26),
                imageOffset: new this.BMap.Size(0, 0)
            });
            let playMarker = new this.BMap.Marker(this.gpsLineList[0], {icon: playIcon}) // 创建标注
            this.map.addOverlay(playMarker);
            let lapsTag = 0;
            let distance = 0;
            for (let i = 1; i < this.gpsLineList.length; i++) {
                (function (j) {
                    setTimeout(function () {
                        _this.map.removeOverlay(playMarker);
                        let line = _this.gpsLineList.slice(j - 1, j + 1)
                        var polyline = new _this.BMap.Polyline(line,
                            {strokeColor: '#2ECF6C', strokeWeight: 8, strokeOpacity: 1});
                        _this.map.addOverlay(polyline);
                        playMarker = new _this.BMap.Marker(_this.gpsLineList[j], {icon: playIcon}) // 创建标注
                        _this.map.addOverlay(playMarker);
                        if (_this.showLapsGpsTag) {
                            distance += _this.map.getDistance(_this.gpsLineList[j], _this.gpsLineList[j - 1]);
                            if (distance >= 1000 * (lapsTag + 1)) {
                                _this.lapsGpsLabel.push(_this.lapsGpsLabel[lapsTag])
                                _this.map.addOverlay(_this.lapsGpsLabel[lapsTag]);
                                lapsTag++;
                            }
                            if (j == _this.gpsLineList.length - 1) {
                                _this.showMapLaps();
                                _this.playTag = false;
                            }
                        }
                    }, i * 50);
                })(i)
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.windowScroll);
    },
}
</script>

<style scoped>

.top-box {
    position: relative;
    width: 100%;
    height: 354px;
}

.top-box-img {
    width: 100%;
}

.map-box {
    width: 100%;
    height: 354px;
}

.sport-back {
    width: 40px;
    position: fixed;
    top: 4px;
    left: 20px;
    z-index: 1111;
}

.icon-shadow {
    border-radius: 50%;
    box-shadow: 2px 2px 4px 1px var(--line-color-2);
}

.sport-map {
    width: 40px;
    position: fixed;
    top: 48px;
    left: 268px;
    z-index: 1111;
}

.sport-share {
    width: 40px;
    position: fixed;
    top: 4px;
    left: 319px;
    z-index: 1111;
}

.sport-arrow {
    width: 40px;
    position: absolute;
    top: 146px;
    left: 319px;
}

.sport-slice {
    width: 40px;
    position: absolute;
    top: 197px;
    left: 319px;
}

.sport-play {
    width: 40px;
    position: absolute;
    top: 248px;
    left: 319px;
}

.total-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: -40px auto 10px;
    z-index: 11;
    position: relative;
}

.user-img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    position: absolute;
    right: 35px;
    border: 6px solid var(--bg-color-2);
    top: -36px;
}

.total-top {
    font-size: 15px;
    color: var(--text-color-1);
    padding-top: 18px;
    margin-left: 11px;
    line-height: 26px;
    display: flex;
    align-items: center;
}

.watch-img {
    width: 24px;
    margin-right: 6px;
}

.dot {
    margin: 0 6px;
}

.distance-box {
    font-size: 17px;
    color: var(--text-color-2);
    margin-top: -8px;
}

.distance-num {
    font-family: PP;
    font-size: 40px;
    color: var(--text-color-1);
    margin-left: 38px;
    margin-right: 5px;
    vertical-align: sub;
}

.start-time {
    float: right;
    color: var(--text-color-1);
    margin-right: 24px;
    margin-top: 23px;
    font-family: PP;
}

.speed-box {
    width: 315px;
    height: 4px;
    background: linear-gradient(90deg, #DC2649 0%, #FFB66B 16%, #FFF568 33%, #A0FF43 50%, #00BB7C 68%, #3D91FF 84%, #2D3BFF 100%);
    border-radius: 0px 0px 0px 0px;
    position: relative;
    margin: 0 auto;
}

.speed-box-bg {
    width: 315px;
    height: 4px;
    margin: 0 auto;
    background: var(--bg-color-1);
}

.fast {
    width: 22px;
    height: 22px;
    background: var(--bg-color-2);
    color: var(--text-color-1);
    font-size: 13px;
    position: absolute;
    left: 25px;
    top: -9px;
    text-align: center;
    line-height: 22px;
}

.slow {
    width: 22px;
    height: 22px;
    background: var(--bg-color-2);
    color: var(--text-color-1);
    font-size: 13px;
    position: absolute;
    right: 20px;
    top: -9px;
    text-align: center;
    line-height: 22px;
}

.total-info {
    width: 315px;
    background: var(--bg-color-1);
    border-radius: 13px 13px 13px 13px;
    margin: 19px auto 0;
    padding-bottom: 15px;
}

.total-item {
    margin-top: 10px;
    text-align: center;
}

.total-van-row .total-item {
    /*margin-left: 10px;*/
}

.total-value {
    font-size: 12px;
    color: var(--text-color-3);
}

.total-value-num {
    font-size: 19px;
    font-family: PP;
    color: var(--text-color-1);
    margin-right: 2px;
}

.total-key {
    font-size: 13px;
    color: var(--text-color-2);
}

.chart-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 25px auto 0;
}

.chart-icon {
    width: 18px;
    vertical-align: bottom;
}

.chart-title {
    font-size: 15px;
    color: var(--text-color-1);
    padding-top: 12px;
    margin-left: 15px;
}

.chart-unit {
    color: var(--text-color-2);
    font-size: 13px;
}

.math-item {
    text-align: center;
    margin-top: 11px;
}

.chart {
    height: 176px;
    width: 100%;
}

.hr-range-box {
    width: 315px;
    height: 270px;
    background: var(--bg-color-1);
    border-radius: 13px 13px 13px 13px;
    margin: 0 auto;
}

.hr-line {
    width: 100%;
    height: 51px;
    position: relative;
}

.hr-line-title {
    font-size: 15px;
    color: var(--text-color-1);
    position: absolute;
    top: 14px;
    left: 19px;
}

.hr-line-desc {
    font-size: 13px;
    color: var(--text-color-2);
    position: absolute;
    top: 34px;
    left: 19px;
}

.percent {
    width: 200px;
    height: 10px;
    position: absolute;
    right: 23px;
    top: 17px;
    overflow: hidden;
}

/deep/ .van-progress__pivot {
    display: none !important;
}

/deep/ .van-progress__portion {
    border-radius: 10px;
}

/deep/ .van-progress {
    border-radius: 10px;
}

.hr-line-percent {
    font-family: PP;
    font-size: 15px;
    color: var(--text-color-1);
    position: absolute;
    right: 23px;
    top: 29px;
}

.hr-line-time {
    font-size: 13px;
    color: var(--text-color-2);
    position: absolute;
    top: 32px;
    right: 69px;
}

.hr-split-line {
    width: 311px;
    border-bottom: 1px solid var(--bg-color-1);
    margin: 20px auto 4px;
}

.pace-split-line {
    width: 311px;
    border-bottom: 1px solid var(--bg-color-1);
    margin: 0px auto 4px;
}

.height-best {
    width: 315px;
    height: 39px;
    background: var(--bg-color-1);
    border-radius: 8px 8px 8px 8px;
    margin: 0 auto;
    position: relative;
    color: var(--text-color-2);
    font-size: 13px;
}

.height-up {
    width: 13px;
    position: absolute;
    left: 36px;
    top: 16px;
}

.height-down {
    width: 13px;
    position: absolute;
    left: 180px;
    top: 16px;
}

.height-up-key {
    position: absolute;
    left: 52px;
    top: 10px;
}

.height-up-value {
    font-family: PP;
    font-size: 17px;
    position: absolute;
    left: 109px;
    top: 6px;
    color: var(--text-color-1);
}

.height-down-key {
    position: absolute;
    left: 196px;
    top: 10px;
}

.height-down-value {
    font-family: PP;
    font-size: 17px;
    position: absolute;
    left: 253px;
    top: 6px;
    color: var(--text-color-1);
}

.height-box {
    padding-bottom: 15px;
}

.train-box {
    width: 345px;
    height: 224px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 15px auto 0;
}

.train-title {
    font-size: 15px;
    color: var(--text-color-1);
    margin-left: 16px;
    padding-top: 15px;
}

.circle-box {
    width: 100%;
    height: 138px;
    position: relative;
}

.aer-box {
    width: 86px;
    height: 86px;
    position: absolute;
    left: 65px;
    top: 10px;
    text-align: center;
}

.aer-text-box {
    width: 100px;
    position: absolute;
    text-align: center;
    top: 0;
    right: -7px;
}

.anaer-box {
    width: 86px;
    height: 86px;
    position: absolute;
    left: 202px;
    top: 10px;
}

.aer-value {
    font-family: PP;
    font-size: 27px;
    color: var(--text-color-1);
    margin-top: 16px;
}

.aer-key {
    font-size: 13px;
    color: var(--text-color-2);
    margin-top: -5px;
}

.aer-level {
    color: var(--text-color-1);
    font-size: 15px;
    margin-top: 28px;
}

.train-load-box {
    width: 177px;
    height: 39px;
    background: var(--bg-color-1);
    border-radius: 8px 8px 8px 8px;
    margin: 0 auto;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
}

.train-recover-box {
    width: 200px;
}

.train-load-key {
    color: var(--text-color-2);
    font-size: 13px;
}

.train-load-value {
    font-size: 17px;
    font-family: PP;
    color: var(--text-color-1);
    margin-left: 9px;
}

.train-recover-value {
    font-size: 17px;
    font-family: PP;
    color: var(--text-color-1);
    margin: 0 5px;
}

.laps-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 15px auto 0;
}

.laps-table-box {
    width: 315px;
    background: var(--bg-color-1);
    border-radius: 13px 13px 13px 13px;
    margin: 15px auto 0;
}

.c5-title {
    width: 289px;
    height: 30px;
    background: var(--bg-color-2);
    border-radius: 5px 5px 5px 5px;
    margin: 0px auto;
}

.gap {
    width: 100%;
    height: 10px;
}

.laps-table-title {
    width: 289px;
    height: 30px;
    background: var(--bg-color-2);
    border-radius: 5px 5px 5px 5px;
    margin: 0px auto;
}

.laps-table-title-item {
    color: var(--text-color-2);
    font-size: 13px;
    display: flex;
    align-items: center;
    height: 30px;
    margin-left: 13px;
}

.laps-table-data {
    width: 289px;
    margin: 0 auto;
    border-bottom: 1px solid var(--bg-color-2);
}

.laps-table-data-item {
    height: 38px;
    font-size: 15px;
    color: var(--text-color-1);
    font-family: PP;
    margin-left: 13px;
    display: flex;
    align-items: center;
}

.laps-table {
    width: 289px;
    margin: 0 auto;
}

.laps-table-title th {
    color: var(--text-color-2);
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: 400;
    width: 25%;
}

.c5-title th {
    color: var(--text-color-2);
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: 400;
    width: 24%;
}

.c5-title th:first-child {
    color: var(--text-color-2);
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: 400;
    width: 4%;
}

.c5 {
    width: 289px;
    margin: 0 auto;
}

.c5 th {
    color: #BBBBBB;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #727A8E;
    font-size: 14px;
    font-weight: 400;
}

.c5 td {
    color: var(--text-color-1);
    height: 38px;
    line-height: 0px;
    border-bottom: 1px solid var(--bg-color-2);
    font-size: 14px;
    font-weight: 400;
    width: 24%;
    text-align: center;
    font-family: PP;
}

.c5 td:first-child {
    color: var(--text-color-1);
    height: 38px;
    line-height: 0px;
    border-bottom: 1px solid var(--bg-color-2);
    font-size: 14px;
    font-weight: 400;
    width: 4%;
    text-align: center;
    font-family: PP;
}

.laps-table td {
    color: var(--text-color-1);
    height: 38px;
    line-height: 0px;
    border-bottom: 1px solid var(--bg-color-2);
    font-size: 14px;
    font-weight: 400;
    width: 25%;
    text-align: center;
    font-family: PP;
}

.total-box-gap {
    height: 16px;
    width: 100%;
}

/deep/ .van-tab {
    font-size: 15px;
}

/deep/ .van-tab:first-child:after {
    content: '';
    position: absolute;
    left: auto;
    top: auto;
    bottom: 14px;
    right: 0;
    height: 40%;
    width: 1px;
    background-color: var(--line-color-1);
    opacity: 0.3;
}

/deep/ .van-tab:nth-child(2):after {
    content: '';
    position: absolute;
    left: auto;
    top: auto;
    bottom: 14px;
    right: 0;
    height: 40%;
    width: 1px;
    background-color: var(--line-color-1);
    opacity: 0.3;
}

/deep/ .van-tabs__nav {
    background-color: var(--bg-color-1);
}

/deep/ .van-tabs {
    background-color: var(--bg-color-1);
}

.triathlon-total-box {
    width: 345px;
    height: 62px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 10px auto 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.icon-box {
    width: 40px;
    height: 40px;
    background: var(--bg-color-1);
    border-radius: 20px;
    margin-left: 23px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.icon-box-img {
    width: 30px;
    height: 30px;
}

.triathlon-distance {
    font-size: 13px;
    color: var(--text-color-2);
    width: 135px;
}

.triathlon-distance-num {
    font-size: 23px;
    font-family: PP;
    color: var(--text-color-1);
    margin-right: 4px;
}

.triathlon-duration {
    color: var(--text-color-2);
    font-size: 15px;
    font-family: PP;
    margin-right: 15px;
}

.laps-icon {
    width: 10px;
}

.col-light {
    color: var(--chart-color-1) !important;
    font-family: Source Han Sans CN, Source Han Sans CN;
}

.col-shadow {
    color: var(--text-color-5);
    font-family: Source Han Sans CN, Source Han Sans CN;
}

.hwpy-box {
    position: fixed;
    left: 124px;
    top: 48px;
    width: 119px;
    height: 36px;
    background: var(--bg-color-2);
    border-radius: 10px 10px 10px 10px;
    font-size: 17px;
    color: var(--text-color-1);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 111;
}

.hwpy-icon {
    width: 16px;
    margin-left: 6px;
}

.hwpy-list-box {
    width: 119px;
    background: var(--bg-color-2);
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.1);
    border-radius: 10px 10px 10px 10px;
    position: fixed;
    top: 98px;
    left: 124px;
    z-index: 111;
}

.hwpy-item {
    font-size: 15px;
    color: var(--text-color-2);
    height: 39px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.hwpy-item:first-child {
    padding-top: 12px;
}

.hwpy-item:last-child {
    padding-bottom: 12px;
}

.publish-input {
    width: 273px;
    height: 42px;
    background: var(--bg-color-1);
    border-radius: 6px 6px 6px 6px;
    margin: 17px auto 15px;
}

/deep/ .van-cell {
    background: var(--bg-color-1);
    border-radius: 6px 6px 6px 6px;
}

/deep/ .van-cell__value--alone {
    color: var(--text-color-3);
}

/deep/ .van-dialog__header {
    font-size: 19px;
    color: var(--text-color-1);
}

.sub-title {
    font-size: 15px;
    color: var(--text-color-2);
    text-align: center;
    margin-top: 12px;
}

.fixed-top {
    height: 44px;
    width: 100%;
    background-color: var(--bg-color-2);
    position: fixed;
    top: 0px;
    z-index: 111;
}

.map-style-box {
    display: flex;
    align-items: center;
    width: 351px;
    justify-content: center;
    margin: 0 12px;
}

.map-style-list {
    flex: auto;
    text-align: center;
    color: var(--text-color-2);
    font-size: 15px;
    height: 95px;
}

.map-icon {
    width: 60px;
    margin-bottom: 6px;
    border: 3px solid transparent;
    border-radius: 8px 8px 8px 8px;
}

.map-icon-selected {
    border: 3px solid var(--chart-color-1);
    border-radius: 8px 8px 8px 8px;
}

/deep/ .van-popup {
    background-color: var(--bg-color-4);
}

.play-map {
    height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/views/sport/04sportDesc.vue